import forEach from "lodash/forEach"

export const ARTWORKS = [
  {
    id: 1,
    projectName: "International Magical Realist Correspondences",
    displayName: {
      vi: "Thư phim Hiện thực huyền ảo",
      en: "International Magical Realist Correspondences",
    },
    artists: [
      {
        fullName: "Đặng Hồng Anh",
        country: "Vietnam",
      },
    ],
    medias: [
      {
        url: "https://vimeo.com/650178912",
        videoId: "650178912",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    markerOffset: 15,
    coordinates: [106.660172, 10.762622],
    displayDescription: {
      vi: `<p>Ý tưởng đến từ hai cuốn tiểu thuyết hiện thực huyền ảo mà cho đến tận bây giờ tôi vẫn nghĩ đến. Chúng đã xuất hiện trong những khoảnh khắc mang giông tố nội tại to nhỏ nào đó khi đang lớn lên – trong một nhân vật đó là tôi. Cuốn tiểu thuyết đầu tiên là Cuộc đời của Pi của Yann Martel, khi tôi là một thiếu niên học lớp tám. Cuốn thứ hai là Kafka bên bờ biển của Haruki Murakami, khi tôi đang đi du lịch thăm một người bạn ở Montreal vào năm cuối đại học. Do mối gắn kết như ma thuật đó của nghệ thuật nên tôi quyết định tìm hiểu, nghiên cứu về hiện thực huyền ảo và thử nghiệm nó trong dự án phim thể nghiệm này. Hiện thực huyền ảo là một phương thức biểu hiện nghệ thuật có ảnh hưởng sâu rộng và được khán giả yêu mến trên khắp thế giới, đặc biệt là trong những nền văn hoá hậu-thuộc địa. Nó mang trình hiện đi ngược lại với tư duy duy lý trong chủ nghĩa hiện thực của phương Tây, kết hợp giữa trần thuật kỳ ảo và hiện thực. Ý tưởng của tôi là làm phim mang ý niệm về sự kết nối. Tôi đã mời các nghệ sĩ và một vài người bạn cùng làm những đoạn phim ngắn bằng ảnh tĩnh để gửi cho nhau. Tôi muốn tạo ra một trải nghiệm cùng sáng tác vì không phải lúc nào cũng được mong chờ những bức thư từ bạn bè. Phim ngắn này là những mảnh phim liền kề nhau - một lời mời gọi mọi người quan tâm đến hiện thực huyền ảo và cùng thử tin rằng có điều gì đó thần kỳ trong những mảnh đời thực của mỗi chúng ta.</p>
      <p><b>Mô tả tác phẩm:</b></p>
      <p>Một phim hiện thực huyền ảo thể nghiệm gồm những mảnh phim liền kề của các nghệ sĩ được làm từ ảnh tĩnh. Một cách tiếp cận tự làm phim dễ dàng thông qua biểu đạt bằng texture hình ảnh mới. Điện ảnh sống giữa đời thực, tâm tư và trí tưởng tượng của mỗi con người. Không cần cầu kỳ và xa gần hết mức có thể, độc thoại cũng được, tùy ý, miễn là gửi cho nhau. Có hồi đáp. Một mong muốn kết nối và thử cùng nhau kể chuyện về cuộc sống của mỗi người.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Đặng Hồng Anh là một gương mặt quen thuộc của các không gian và nhóm nghệ thuật độc lập tại Hà Nội. Cô tham gia vào các chương trình và hoạt động với tư cách nhà làm phim / nghệ sĩ thị giác. Các tác phẩm của cô khai thác những trải nghiệm, giấc mơ và thực tại trong Việt Nam đương đại. Chúng bao gồm cả hư cấu và phi-hư cấu, phản tư trải nghiệm cá nhân cũng như tìm kiếm những câu chuyện từ mọi người xung quanh. Cô thích làm những tác phẩm giàu trí tưởng tượng và đồng thời ghi lại, nắm bắt những hình ảnh của thế giới hiện nay. Gần đây, cô quan tâm về con người và nhiều vấn đề liên quan như hậu-thuộc địa, giới tính, sức khỏe tinh thần, bạo lực và môi trường.</p>
      <p>Hồng Anh mong muốn làm những thước phim và tác phẩm nghệ thuật X-quang như những nhà làm phim và nghệ sĩ đã truyền cảm hứng cho cô. Các tác phẩm của cô đã trưng bày tại những triển lãm và dự án như Dự án # COM tại Six Space (2017), Trình chiếu Phim Tháng Tư của Heritage Space (2018), chương trình Mở Xưởng tại Á Space (2018), “Đêm Dài Lắm Mộng” - một tác phẩm video sắp đặt tại Á Space (2019), và một buổi trình chiếu phim tại Khuấy 01 (2020).</p>
      `,
      en: `<p>The idea came from two fantasy novels that I still think about to this day. They showed up in some bigger or smaller inner stormy moments of the process of growing up – in one character that was me. The first novel was The Life of Pi by Yann Martel, when I was a teenager in eighth grade. The second is Kafka by the Sea by Haruki Murakami, when I was on a trip to visit a friend in Montreal in my senior year of college. Because of that magical-like connection of art, I decided to learn, research about magical reality and experiment it in this experimental film project. Magical realism is a far-reaching method of artistic expression and is loved by audiences around the world, especially in post-colonial cultures. It carries a representation that goes against the rational thinking in Western realism, combining fantasy narrative and realism. My idea is to make a movie with the concept of connection. I invited some artists and a few friends to make short films using still images to share with each other. I want to create a co-writing experience because letters from friends are not always expected. This short film is a juxtaposition of films - an invitation to everyone to pay more attention in magical realism and to try to believe that there is something magical in the practical fragment of life in side each of us.</p>
      <p><b>Artwork description:</b></p>
      <p>An experimental magical realism film featuring adjacent pieces of films made from still images by other artists. An easy DIY approach through new visual texture expressions. Cinema lives in real life, the mind and imagination of each person. No need to be fussy and as close as possible, monologue is fine, whatever you want, as long as it's shared with each other. There are responses. A desire to connect and a try to tell each other's stories together.</p>
      <p class="title-section">Biography</p>
      <p>Dang Hong Anh is a familiar face of independent art spaces and groups in Hanoi’s scene, involving in programs and activities as a filmmaker/visual artist. Her works explore experiences, dreams and realities in contemporary Viet Nam. She reflects on her personal experiences and looks for stories from others at the same time, working on both fiction and non-fiction. She likes making works for imaginations and capturing pictures of the current world. Currently, she’s interested in people and multiple issues such as postcolonialism, gender, mental health, violence and the environment.</p>
      <p>Hong Anh wants to make x-ray films and arts like filmmakers and artists that have inspired her. She has presented works in exhibitions and projects such as # COM project at Six Space (2017), Heritage Space April Film Screening (2018), open Studio showcase in A Space (2018), ‘Too many long night dream’ - a video installation in A Space (2019), a film showcase in Khuay 01 (2020).</p>
      `,
    },
  },
  {
    id: 2,
    projectName: "FLAGS FLIES",
    displayName: {
      vi: "Cờ Bay",
      en: "Flags Fly",
    },
    artists: [
      {
        fullName: "Daniel Rode",
        country: "Germany",
      },
      {
        fullName: "Heaven Baek",
        country: "Korea",
      },
    ],
    markerOffset: 15,
    coordinates: [8.562558, 48.471185],
    multiCoordinates: [
      [8.562558, 48.471185],
      [130.049612, 40.868021],
    ],
    medias: [
      {
        url: "/images/flags_files/flagsflies-dresden-1.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-dresden-2.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-dresden-3.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-dresden-4.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-dresden-5.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-dresden-6.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-dresden-7.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-1.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-2.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-3.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-4.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-5.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-6.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-7.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-8.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-9.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-hanoi-10.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-seoul-1.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-seoul-2.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-seoul-3.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-seoul-4.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-seoul-5.jpg",
        type: "image",
      },
      {
        url: "/images/flags_files/flagsflies-seoul-6.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>những khoảng cách vẫn thế / di chuyển bị hạn chế / thiếu liên lạc / những khuôn mắt đóng băng / bên trong màn hình / vẫn cười / hãy sẵn sàng, xây cầu, đếm ngày và trong khi đó / thả cho cờ bạn bay</p>
      <p>Hai nghệ sĩ, biết nhau từ MAP 2017 ở Hà Nội, sẽ tạo ra những lá cờ cho ba địa điểm Seoul, Hà Nội và Dresden.</p>
      <p>Ở Hà Nội cờ sẽ bay tại địa điểm triển lãm MAP 2021, ở Dresden địa điểm là Viện Goethe Dresden, ở Seoul địa điểm là không gian Changdong của Bảo tàng Nghệ thuật Hiện đại và Đương đại quốc gia Hà Quốc (MMCA).</p>
      <p>* Viện Goethe Dresden tài trợ việc in và lắp đặt các lá cờ tại Dresden.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Heaven Baek (sinh năm 1984) học chuyên ngành Nghệ thuật Phương tiện tại Viện Công nghệ Hoàng gia Melbourne, Úc và tốt nghiệp Thạc sĩ Mỹ thuật tại trường Đại học Nghệ thuật Glasgow, Anh Quốc. Các dự án của cô được trưng bày tại nhiều nơi trên thế giới như Abu Dhabi, Frankfurt, Hà Nội, Glasgow, Tokyo, Paris, Seoul, Reykjavik, Barcelona và nhiều thành phố khác. Cô tham gia nhiều cuộc triển lãm nhóm, trong đó có Triển lãm Ogamdo tại Bảo tàng Manarat al saadiyat (Abu Dhabi, năm 2020), Triển lãm lưỡng niên Gwangju 2018 với chủ đề Những đường biên tưởng tượng, Triển lãm  m thanh Cộng đồng tại Gallery Nghệ thuật Arko, Seoul năm 2015, và Triển lãm Caesura trong khuôn khổ của Lễ hội Nghệ thuật thị giác Glasgow International năm 2014. Cô cũng có các triển lãm cá nhân như So there was (Saro Leon Gallery, Las Palmas, 2019), Wolf and Wolf (Arario Gallery, Seoul, 2017) và Our Lady Vengeance (Không gian Mỹ thuật Insa của Hội đồng Nghệ thuật Hàn Quốc - Arko, Seoul, 2013). Cô hiện hoạt động tại Đức và Hàn Quốc.</p>
      <p>Xem thêm về nghệ sĩ tại:</p>
      <p><a href="http://www.heavenbaek.com" target="_blank">http://www.heavenbaek.com</a></p>
      <p>Nghệ sĩ Đức Daniel Rode, sinh năm 1971, làm việc chủ yếu bằng phương thức Vẽ và Sắp đặt. Thực hành nghệ thuật của anh theo trường phái ý niệm, tập trung vào các tác phẩm sử dụng từ ngữ, với các kích cỡ khác nhau, bao gồm cả các tấm banner ở không gian công cộng.</p>
      <p>Anh đã từng học Giáo dục nghệ thuật và Khoa học giáo dục tại trường Đại học Greifswald, Đức và đã giảng dạy Thực hành nghệ thuật tại ngôi trường đó trong 5 năm. Anh đã có bằng Cử nhân và Thạc sĩ tại Học viện Mỹ thuật Dresden. Từ 2009 đến 2014, anh sống ở Cairo, Ai Cập. Các chuyến lưu trú, các dự án và triển lãm đã đưa anh đến Hy Lạp, Anh, Tây Ban Nha, CH Séc, Thuỵ Sĩ, Phần Lan, Mỹ, Canada, Bahrain và Việt Nam. Anh là đồng sang lập của Modul-Kunstraum ở Dresden (2006 - 2009), một không gian nghệ thuật phi lợi nhuận do nghệ sĩ điều hành tại Dresden, Đức. Anh sống và làm việc tại Dresden và Berlin.</p>
      <p>Xem thêm về nghệ sĩ tại:</p>
      <p><a href="http://www.danielrode.de" target="_blank">http://www.danielrode.de</a></p>
      `,
      en: `<p>distances are the same  /  traveling gets sticky  /  lacking of contact  /  faces frozen  /  inside of screens  /  smile anyway  /  get ready, build the bridge, count the days and meanwhile  /  fly your flags</p>
      <p>Two artists, knowing each other from MAP 2017 in Hanoi, will create flags for three locations: Seoul, Hanoi and Dresden.</p>
      <p>Hanoi location will be at the exhibition venue for MAP 2021, Dresden location is the Dresden Goethe-Institute, Seoul location is the Changdong space of the MMCA.</p>
      <p>* The Goethe-Institut Dresden funds the printing and installation of the Dresden flags.</p>
      <p class="title-section">Biography</p>
      <p>Heaven Baek (b.1984) studied Media Arts in Royal Melbourne Institute of Technology, Australia, and received her MFA at Glasgow School of Art, UK. Her projects has been shown internationally at  Abu Dhabi, Frankfurt, Hanoi, Glasgow, Tokyo, Paris, Seoul, Reykjavik, Barcelona and more. She has participated in numerous group exhibitions including Ogamdo, Manarat al saadiyat Museum (Abu Dhabi, 2020), Imagined Borders (Gwangju Biennale, 2018), Sound of community (Arko Art Center, Seoul, 2015), and Caesura (Glasgow International, 2014). She has had her solo exhibitions So there was (Saro Leon Gallery, Las Palmas, 2019), Wolf and Wolf (Arario Gallery, Seoul, 2017) and Our Lady Vengeance (Insa Art Space of the Arts Council Korea, Seoul, 2013). She is currently based in Germany and South Korea.</p>
      <p>More about the artist at:</p>
      <p><a href="http://www.heavenbaek.com" target="_blank">http://www.heavenbaek.com</a></p>
      <p>The German artist Daniel Rode, born 1971, works mainly in Drawing and Installation. His art practice is conceptual, with a focus on text based works, variable in size including banners in public space. He studied Art Education and Educational Sciences at Greifswald University, Germany and taught there Art Practice for five years. He also achieved a Diploma and Master Class certificate at Dresden Academy of Fine Arts. From 2009 until 2014 he lived in Cairo Egypt, residencies, projects and exhibitions took him to Greece, England, Spain, Czech Republic, Switzerland, Finland, the US, Canada, Bahrain and Vietnam.</p>
      <p>He was the co-founder of Modul-Kunstraum in Dresden (2006 - 2009), a non profit and artist-run art space in Dresden, Germany. He lives and works in Dresden and Berlin.</p>
      <p>More about the artist at:</p>
      <p><a href="http://www.danielrode.com" target="_blank">http://www.danielrode.de</a></p>
      `,
    },
  },

  {
    id: 3,
    projectName: "Zoom Walking Meditation: Noticing Through a Prism",
    displayName: {
      vi: "Thiền Đi Bộ qua Zoom: Nhận biết qua một Lăng kính",
      en: "Zoom Walking Meditation: Noticing Through A Prism",
    },
    artists: [
      {
        fullName: "Daniel Kerkhoff",
        country: "US",
      },
    ],
    markerOffset: 15,
    coordinates: [-120.932217, 39.609251],
    medias: [
      {
        url: "https://vimeo.com/649363114",
        videoId: "649363114",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "https://vimeo.com/649363562",
        videoId: "649363562",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "https://vimeo.com/653666681",
        videoId: "653666681",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    displayDescription: {
      vi: `<p>Trong thời gian đại dịch, tôi đã có rất nhiều dịp để tham gia các buổi họp gặp qua Zoom nhưng luôn ngần ngại thực hiện chúng, một phần do trải nghiệm ngồi, phải nói chuyện và hiển thị khuôn mặt trong các buổi họp gặp chính thức.</p>
      <p>Với mong muốn tham gia MAP 2021, tôi đã quyết định tham gia một vài buổi gặp qua Zoom suốt mùa hè năm 2021 cho chương trình lưu trú. Điều này tạo cảm hứng cho tôi thực hiện dự án của mình giống như các buổi gặp qua Zoom mà chúng tôi đã có, nhưng tôi muốn chuyển hướng dạng thức buổi gặp qua Zoom. Với suy nghĩ đó, cùng với các dự án trước đó của tôi có liên quan đến việc ghi lại các cuộc đi bộ, tôi đã quyết định tạo ra một cuộc gặp qua Zoom mà đó là một buổi thiền đi bộ. Hướng dẫn chính trái ngược lại hoàn toàn với hướng dẫn của các buổi gặp qua Zoom điển hình ở chỗ người tham gia được yêu cầu không để lộ mặt và không nói. Thay vào đó, người tham gia vào buổi Thiền Đi Bộ Qua Zoom sẽ đi bộ ở nơi họ đang có mặt và chia sẻ với chúng tôi những gì họ nhận thấy trên đường đi của họ. Với những người không thể rời khỏi nhà, họ có thể chia sẻ những gì có ở nhà họ và đi xung quanh để ý nhận thấy những chi tiết thường bị bỏ qua.</p>
      <p>Tôi hình dung Zoom gallery như một lăng kính giống như cách một lăng kính làm lộ ra tất cả các sắc màu có trong ánh sáng trắng. Tất cả chúng tôi đi bộ cùng nhau trong buổi đi bộ qua Zoom giống như thể quang phổ này, và trong hoạt động chung thực hiện cùng nhau, chúng tôi đang sẻ chia và kết nối theo một cách mang chúng tôi lại gần nhau hơn và cảm thấy bớt cách xa một cách đầy hy vọng.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Daniel Kerkhoff (sinh 1965) là nghệ sỹ thị giác đến từ Minneapolis, tiểu bang Minnesota (Mỹ). Ông theo học hội họa và tranh phối chất tại The Art Students League ở New York, đồng thời tu nghiệp giảng dạy tại San Francisco (United States), Kuki-shi (Japan), and San Gimignano (Italy). Từ năm 2009, Daniel Kerkhoff tự tiến hành những đợt lưu trú của riêng mình tại Ghana, Ecuador, và Việt Nam. Thông qua quá trình đó, Daniel sống hòa mình vào cộng đồng địa phương, phát triển sáng tác bằng các thực hành nghệ thuật (sắp đặt), viết nhật kí bằng thơ, các hoạt động sáng tạo cùng trẻ em, tham gia tổ chức triển lãm, làm việc với các nghệ sĩ, hỗ trợ các thư viện nghệ thuật và thư viện cộng đồng, và nhiều hoạt động đa dạng khác hướng đến sự chia sẻ và kết nối.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://danielkerkhoff.com" target="_blank">https://danielkerkhoff.com</a></p>
      `,
      en: `<p>During the pandemic, I have had many opportunities to participate in Zoom meetings but have been reluctant to do so partly because of the formal meeting experience of sitting, having to talk and show my face.</p>
      <p>With the desire to join MAP 2021, I decided to participate in several Zoom meetings over the summer of 2021 for the residency. This inspired me to do my project similar to the Zoom meetings we were having, but I wanted to avert or subvert the Zoom meeting format. With that in mind, and with my previous art projects related to documenting walks, I decided to create a Zoom meeting that is a walking meditation. The main guidelines would be opposite of typical Zoom meetings in that participants are asked not to show their faces and not to talk. Instead, participants in the Zoom Walking Meditation would walk in the places they are and share with us what they are noticing on their walk. For those who could not leave their home, they would share what is in their place and walk around noticing the details that are often overlooked.</p>
      <p>I envisioned the Zoom gallery as a prism similar to how a prism reveals all the colors that are within white light. All of us walking together during the Zoom walk are like this spectrum of light, and in our shared activity,  we are sharing and connecting in a way that brings us closer together and hopefully feeling less distant.</p>
      <p class="title-section">Biography</p>
      <p>Daniel Kerkhoff (b. 1965) is a visual artist from Minneapolis, Minnesota whose art practice includes painting, drawing, mixed media, collage, sculpture, installation, photography, and community art. He studied drawing, painting, and collage at the Art Students of New York, NYC as well as with instructors in San Francisco (U.S.A), Kuki-shi (Japan), San Gimignano (Italy) and Kumasi (Ghana). Since 2009, he has been creating his own artist-in-residencies in Adugyama, Ghana, Sisid-anejo, Ecuador, and Hanoi, Vietnam. For these residencies, he embeds himself in a community, creates art and art installations, curates exhibitions, does art with children, meets with other artists, provides materials for libraries, documents and shares his experiences on social media, and does a variety of other actions of creating, witnessing, sharing, and connecting.</p>
      <p>More about the artist at:</p>
      <p><a href="https://danielkerkhoff.com" target="_blank">https://danielkerkhoff.com</a></p>
      `,
    },
  },

  {
    id: 4,
    projectName: "The Imagined (?) Memoir of the Tonkinese (?) Woman",
    displayName: {
      vi: "Hồi ký Tưởng tượng (?) của Người phụ nữ Bắc bộ (?)",
      en: "The Imagined (?) Memoir of the Tonkinese (?) Woman",
    },
    artists: [
      {
        fullName: "Quỳnh Lâm",
        country: "Vietnam",
      },
    ],
    markerOffset: 15,
    coordinates: [105.804817, 21.028511],
    medias: [
      {
        url: "https://vimeo.com/650038629",
        videoId: "650038629",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    displayDescription: {
      vi: `<p>Video được tạo trong quãng thời gian khó khăn ở Hoa Kỳ khi cơn đại dịch toàn cầu cản trở khả năng làm việc, di chuyển, kết nối với người khác cũng như khả năng trở về nhà của mọi người. Tôi muốn tạo ra một tác phẩm nói về truyền thống bắt rễ từ đất Việt cũng như trải nghiệm thực tế ở nước ngoài -- cả hai phương thức này có vai trò tích cực và tiêu cực ra sao. Bị chia cắt khỏi quê hương nhưng vẫn luôn chịu ràng buộc bởi những sợi tơ mỏng manh dưới dạng ngôn ngữ, lịch sử và ký ức.</p>
      <p>Ý tưởng của tôi liên quan tới chủ đề khoảng cách TRẮNG nói về sự ly hương trong cơn đại dịch toàn cầu của bản thân như một trong những người châu Á. Tôi bị mắc kẹt tại Mỹ trong nhiều tháng suốt năm nay. Dịch bệnh đã buộc tôi phải sống xa xứ, và vì vậy, khiến tôi cảm thấy như một kẻ tị nạn trong một năm rưỡi qua. Khi phải sống xa quê, tôi đã tạo ra tác phẩm video này như để đáp lại làn sóng kỳ thị người châu Á (Asian Hate movement) ở Mỹ, nơi tôi tận mắt chứng kiến những vụ việc tương tự đã củng cố sự đồng cảm của tôi đối với những người chịu tác động bởi các làn sóng căm thù người châu Á mang tính hệ thống tràn ngập các bản tin năm ngoái.</p>
      <p>Tôi cảm nhận một sự gần gũi với Joseph Beuys và ý tưởng của ông, đặc biệt qua tác phẩm trình diễn của Beuys mang tên “Tôi thích nước Mỹ và nước Mỹ thích tôi” (1974). Dựa trên trải nghiệm của riêng mình trong hơn ba năm sống ở Mỹ, tôi muốn có một cuộc đối thoại tiếp nối phản hồi lại tác phẩm của ông sau gần 50 năm.</p>
      <p>Tôi cũng thấy rằng tác phẩm của mình tương thích với chủ đề của MAP 2021 khi liên hệ với câu nói “Nghệ thuật chính là khoảng cách từ bản thể đến nỗi thống khổ mà thời gian tạo ra” (Albert Camus)</p>
      <p class="title-section">Tiểu sử</p>
      <p>Nguyễn Đức Diễm Quỳnh (hay còn được biết đến với tên gọi Quỳnh Lâm) là một nghệ sĩ liên ngành có xuất thân từ kiến trúc, hoạt động nghệ thuật qua trình diễn, video, sắp đặt, và tác phẩm ý niệm. Cô nhận được Học bổng chính phủ Fulbright (Hoa Kỳ), là chủ nhân Giải thưởng “The 2021 AAF/Seebacher Prize for Fine Arts” của American Austrian Foundation; đạt Giải Đặc biệt do Giám khảo trao tặng (Special Jury Prize) của Giải thưởng Art Future 2019 tại Đài Loan; thuyết trình tại Hội thảo quốc tế “ReVIEWING Black Mountain College 11” (Hoa Kỳ); và là nghệ sĩ lưu trú tại các trại sáng tác do Ragdale Foundation (Illinois, Hoa Kỳ), Hambidge Center for Creative Arts & Sciences (Georgie, Hoa Kỳ), và Oak Spring Garden Foundation (Virginia, Hoa Kỳ) tổ chức. Quỳnh đã từng triển lãm tác phẩm của mình ở cả trong và ngoài nước, trong đó có một số trưng bày đáng lưu ý là Trung tâm nghệ thuật đương đại The Factory (FCAC, TP. Hồ Chí Minh), Hội chợ thường niên Art Formosa (Đài Loan), Trung tâm Nghệ thuật đương đại Vincom (Hà Nội), Richard Koh Fine Art Gallery (Singapore), Gallery ONKAF (New Delhi), triển lãm do Mana Contemporary (New Jersey, Chicago, Miami) và CADAF (Contemporary & Digital Art Fair) phối hợp tổ chức, Stamford Arts Center (Singapore), và Bảo tàng Nghệ thuật đương đại Nashville (Museum of Contemporary Art Nashville-MOCAN, Hoa Kỳ). Triển lãm sắp tới của cô được diễn ra tại Bảo tàng Palazzo Costanzi, Trieste, Ý vào tháng 11/2021. Các tác phẩm của cô được giới thiệu trên nhiều ấn phẩm như chuyên đề Vietnam: New Winds Collection (Luciano Benetton Collection, năm 2015) của Tuyển tập Imago Mundi, Saigon Artbook (Ấn phẩm 6, năm 2016), XEM (Số 7, năm 2017), Inlen (Số 2, năm 2017), Frame to Focus: Vietnamese American Women Artists (do Phòng tranh Catherine G. Murphy Gallery tài trợ, năm 2020). Những cuốn sách nghệ thuật của cô--một phần của dự án xuất bản ‘Vietnam Artist Books Project’ do Indochina Arts Partnership thực hiện và Quỹ Trao đổi và Phát triển Văn hoá Đan Mạch (CDEF) tài trợ--có mặt trong danh mục tài liệu của một số thư viện như Bảo tàng Nghệ thuật Đương Đại MoMA (New York), Yamamoto Gendai, Bay Library, Phòng tranh Salon Saigon, Địa Project, Thư viện Đại học California UCLA (Los Angeles), Thư viện John C. Hodges (Bộ sưu tập đặc biệt) của Đại học Tennessee (UTK), và nhiều trung tâm nghệ thuật khác.</p>
      <p><a href="https://www.quynh-lam.com/bio" target="_blank">https://www.quynh-lam.com/bio</a></p>
      `,
      en: `<p>The video was created during a difficult time in the U.S., due to the global pandemic and how it strains one's ability to work, travel, connect with others, and return home. I wanted to produce a work that spoke to traditional roots in Vietnam as well as the diasporic experience abroad--how both of these modalities could be positive as well as negative. Separated from one's homeland yet always tied to it by strands of diaphanous fibers in the form of language, history, and memory.</p>
      <p>My concept relating to the WHITE distance theme concerns being among the Asian diaspora due to the global pandemic. I was stuck in the United States for several months this year. The pandemic has forced me to live in the diaspora and, hence, made me feel something like a refugee for the past year and a half. Being distanced from my home country, I created this video, reacting to the racism/Asian Hate movement in the United States where I witnessed similar incidents firsthand that undergirded my empathy for those affected by the systemic episodes of Asian hate reported in the news last year.</p>
      <p>I feel a kinship to Joseph Beuys and his concept, especially throughout his work “I like America and America likes Me” (1974). Based on my experience living in the United States for more than three years, I want to have a continued dialogue response to his piece after almost 50 years.</p>
      <p>I also see that my work is matched with the MAP 2021 theme focus mentioned: “Art is the distance that time gives to suffering” (Albert Camus).</p>
      <p class="title-section">Biography</p>
      <p>Nguyễn Đức Diễm Quỳnh (otherwise known as Quỳnh Lâm) is an interdisciplinary artist with a background in architecture, working in performance, video, installation, and conceptual work. She is a Fulbright scholar, a winner of The 2021 AAF/Seebacher Prize for Fine Arts from the American Austrian Foundation; a recipient of Special Jury Prize from the 2019 Art Future Prize in Taiwan; a presenter at the international conference “ReVIEWING Black Mountain College 11”; and artist fellow at Ragdale Foundation (Illinois, USA), Hambidge Center for Creative Arts & Sciences (Georgia, USA); and Oak Spring Garden Foundation (Virginia, USA). Quỳnh has exhibited work in Vietnam and abroad; some highlights include The Factory Contemporary Arts Center (Ho Chi Minh City), Art Formosa (Taipei), The Vincom Center for Contemporary (Hanoi), Richard Koh Fine Art Gallery (Singapore), Gallery ONKAF (New Delhi), Mana Contemporary (New Jersey, Chicago, Miami) – in partnership with CADAF (Contemporary & Digital Art Fair), Stamford Arts Center (Singapore), and Museum of Contemporary Art Nashville (MOCAN). Her upcoming exhibition will be in Palazzo Costanzi Museum in Trieste, Italy in November 2021. Her works have been featured in many publications: Imago Mundi–Vietnam: New Winds Collection (Luciano Benetton Collection, 2015), Saigon Artbook (edition 6, 2016), XEM (issue 7, 2017), Inlen (issue 2, 2017), Frame to Focus: Vietnamese American Women Artists (sponsored by The Catherine G. Murphy Gallery, 2020). Her artbooks--a part of the 'Vietnam Artist Books Project' of Indochina Arts Partnership, which was sponsored by the Danish Cultural Development and Exchange Fund--have been accessioned to several libraries, e.g. the MoMA, Yamamoto Gendai, Bay Library, Salon Saigon, Dia Project, UCLA library, UTK John C. Hodges Library (Special Collections), and other art hubs.</p>
      <p><a href="https://www.quynh-lam.com/bio" target="_blank">https://www.quynh-lam.com/bio</a></p>
      `,
    },
  },

  {
    id: 5,
    projectName: "SEVEN DAYS",
    displayName: {
      vi: "BẢY NGÀY",
      en: "SEVEN DAYS",
    },
    artists: [
      {
        fullName: "Katja Jug",
        country: "Switzerland",
      },
      {
        fullName: "Mai Huyền Chi",
        country: "Vietnam",
      },
    ],
    markerOffset: 15,
    multiCoordinates: [
      [7.26448, 46.05027],
      [106.598396, 17.465939],
    ],
    medias: [
      {
        url: "https://vimeo.com/649364269",
        videoId: "649364269",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "https://vimeo.com/650370189",
        videoId: "650370189",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    displayDescription: {
      vi: `<p>BẢY NGÀY là một dự án kết hợp giữa nhà làm phim - nghệ sĩ Mai Huyền Chi (TP Hồ Chí Minh, Việt Nam) và nghệ sĩ thị giác Katja Jug (Zurich, Thuỵ Sĩ). Trong bảy ngày, cả hai nghệ sĩ đã mời bạn bè và người lạ khắp thế giới tham gia một thử nghiệm online của họ.</p>
      <p>Với Chi, đó là việc dành khoảng thời gian đầu ngày định hình những khoảnh khắc thân mật và ứng biến những cuộc gặp gỡ qua mạng mà cô không được thông báo trước. Sự khởi đầu của Chi hướng tới một không gian ảo thân mật ngẫu hứng. Khách đến và đi bất cứ khi nào họ muốn. Thời gian được coi như một tấm khung tranh/studio trống. Nghệ sĩ và khách của cô “vẽ" và “điêu khắc" thời gian khi sự tương tác của họ được sinh ra tự nhiên và lặng lẽ trong khoảng không gian ảo.</p>
      <p>Lấy cảm hứng từ Weather Reports của David Lynch, và tinh thần một trích dẫn từ cuốn sách Psychomagic của nhà làm phim Alejandro Jodorowosky: “Những gì nhận được phải được chia sẻ", Katja đã mời mọi người báo cáo các bữa ăn hàng ngày của họ vào thời điểm cuối ngày. Đối với Katja, vẻ đẹp của tính tập thể  được phản ánh qua sự thật giản đơn rằng dù người tham gia có sống ở đâu trên thế giới, thì họ hầu hết đều có một điểm chung là cuộc sống hàng ngày của họ đều được cấu trúc bởi ba bữa ăn. Trong khung thời gian một tuần, vào lúc chiều - cuối ngày của bảy ngày liên tiếp, người tham gia báo cáo các bữa ăn của họ và kể tên các nguyên liệu và/hoặc cách chuẩn bị chúng. Hình thức và nội dung đóng góp của mỗi cá nhân được xác định qua hướng dẫn cụ thể của nghệ sĩ.</p>
      <p>Trung tâm của dự án chung này là sự kết hợp giữa khởi đầu giả tưởng của Chi - một khung tranh trống và kết thúc mong muốn của Katja - gói lại một ngày; sự khám phá của Chi về tính thân mật và lời mời chia sẻ cảm nhận công khai tới đại chúng của  Katja. Trong sự đối nghịch này, chúng tôi thấy mình suy ngẫm về các chủ đề: kết thúc / khởi đầu, riêng tư / công khai.</p>
      <p class="title-section">Tiểu Sử</p>
      <p>Katja Jug là một nghệ sĩ thị giác thực hành dựa trên các phương tiện tổng hợp. Tác phẩm của cô thường xuất hiện dưới dạng ảnh dàn dựng, sắp đặt, tức thời và sách nghệ sĩ. Cô tập trung vào các chủ đề của cuộc sống hàng ngày như khí hậu, dinh dưỡng và danh tính. Ấn phẩm mới nhất của cố là cuốn sách ảnh "Frozen Unfrozen" – dưới hình thức Tiểu thuyết Áp-phích được tài trợ bởi Hội đồng Nghệ thuật Thụy Sĩ Pro Helvetia - là một định dạng nghệ thuật độc lập thể hiện mối quan tâm trong thời gian dài của Jug về việc làm thế nào thể hiện cảm quan của các thực hành về nhiệt độ bằng hình ảnh. “Frozen Unfrozen” kể về câu chuyện của một người đàn ông và một người phụ nữ gặp nhau trong một căn hộ không có hệ thống sưởi ở Trùng Khánh, Trung Quốc. Các bức ảnh, bản vẽ và từ ngữ được kết hợp thành một trải nghiệm ba chiều và từ nhiều giác quan, đồng thời mô tả cách các nhân vật chính sống trong căn hộ và khu vực và xung quanh của họ.</p>
      <p>Katja Jug là tác giả duy nhất của “Frozen Unfrozen”, A Poster Novel (Edition Fink 2021), Hermes Kochbuch”, Artist's Book (Bern 2013),“Yellow”, Artist's Book (Singapur 2015), “Kính gửi bà Rosenberg”, Auswirkungen einer Suche nach Madonna, Sách nghệ sĩ (Zürich 2004). Công việc của cô đã được xuất bản trong số những người khác trên ARCH +, Journal for Architecture and Urbanism (tạp chí Kiến trúc và Đô thị), Tạp chí FCL, Natural Ventilation Revisited Revisited, SAFARI, Projekte u. Reflexionen zur Kulturvermittlung in der Schule, LebensMittel Essen und Trinken in den Künsten und Kulturen, nhà xuất bản Diaphanes.</p>
      <p>Katja Jug đã tham gia các triển lãm cá nhân và nhóm ở Thụy Sĩ và quốc tế, đồng thời nhận được nhiều tài trợ và giải thưởng khác nhau.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://www.katejug.net" target="_blank">https://www.katejug.net</a></p>
      <p>Mai Huyền Chi (Chi Mai) là một cây bút kiêm nhà làm phim người Việt Nam.</p>
      <p>Tốt nghiệp chương trình Thạc sĩ Biên kịch tại Trường Điện ảnh London, cô từng đảm nhiệm vai trò biên kịch phim A Brixton Tale (Đề cử Phim truyện Hay nhất, Slamdance 2021), Chàng Vợ Của Em (Giải Cánh Diều Vàng cho Phim Điện ảnh Xuất sắc Nhất 2018), và Cô gái Đắk Lắk (2021). Tác phẩm đạo diễn đầu tay của cô, phim tài liệu ngắn "Thì Sông Cứ Chảy", lọt vào vòng chung cuộc giải Phim hay nhất năm 2015 của Vimeo. Tiếp nối bộ phim tài liệu này, Chi đang phát triển The River Knows Our Names, phim truyện đạo diễn đầu tay. Phim kể về cộng đồng vô quốc tịch trên sông Mê Kông gần biên giới Campuchia - Việt Nam và sẽ sớm tuyển tuyển người tham gia vào bộ phim. Dự án giành Giải thưởng Viễn Đông Udine tại Diễn đàn Tài trợ Điện ảnh của Hồng Kông và du ngoạn tới Thị trường Đồng Sản xuất Tiêu điểm Châu Á (Liên hoan phim Viễn Đông 2020), Locarno Open Doors, SEAPitch của Liên hoan phim Bangkok ASEAN, và Feature Lab của Liên hoan phim Quốc tế Singapore. Sản xuất dự tính sẽ tiến hành trong năm 2023.</p>
      <p>Ngoài phim ảnh, Chi còn hợp tác với các nghệ sĩ thuộc nhiều lĩnh vực khác nhau cùng sản xuất phim múa, sắp đặt video, và các tác phẩm trình diễn đa phương tiện.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://www.chimaian.com" target="_blank">https://www.chimaian.com</a></p>
      `,
      en: `<p>SEVEN DAYS is a joint-project between filmmaker-artist Mai Huyen Chi (Ho Chi Minh, Vietnam) and visual artist Katja Jug (Zurich, Switzerland). During seven days, the artists invited friends and strangers from around the earth to join them in an online experiment.</p>
      <p>With Chi, it was about spending the beginnings of her days shaping moments of intimacy and improvised plays in a virtual room with visitors she received without knowing in advance. Chi’s beginning aims to create a virtual space of intimacy that is not pre-mediated. The visitors come and leave at any time they want. Time was treated as a blank canvas/ studio. The artist and her visitors “painted” and “sculpted” time as their interactions are borne organically and silently out of the moment in a virtual space.</p>
      <p>Inspired by David Lynch’s Weather Reports, and in the spirit of the quote by filmmaker Alejandro Jodorowosky in his book Psychomagic: “What one receives must be shared“, Katja invited people to report their daily meals at the end of their days. To Katja, the beauty of collectivity is reflected in the simple fact that regardless of where in the world the participants live, they all have in common that their everyday life is mostly structured by three meals. In the cycle of a certain week, on seven consecutive days in the evening- by the end of a day-, the participants give a report on the meals they have eaten and pass on the ingredients and/or preparation of one of those meals. The form and content of the individual contributions were defined by means of concrete instructions given by the artist.</p>
      <p>At the centerpoint of this joint-project is the juxtaposition of Chi's imagined beginnings and Katja’s desired endings, Chi’s start-of-the-day clean slate and Katja’s end-of-the-day wrap-ups, and Chi’s exploration into intimacy and Katja’s open invite to the act of publicly sharing one’s experience. In this dichotomy, we find ourselves contemplating the themes: the end/ the beginning, privacy/ public.</p>
      <p class="title-section">Biography</p>
      <p>Katja Jug (kajug.studio@gmail.com) is a visual artist working with mixed media. Her work is displayed as staged photographs, installations, happenings and artist's books. She deals with themes of everyday life such as climate, nutrition and identity. The latest publication, of the photo book "Frozen Unfrozen", a Poster Novel, funded by Swiss Arts Council Pro Helvetia, is an autonomous artistic formulation of her longstanding preoccupation with the visual and sensorial representation of thermal practices. „Frozen Unfrozen” tells the story of a man  and  a  woman  who  meet  in  an  unheated apartment in Chongquing, China. Photos, drawings and words are combined into a three dimensional and multi-sensorial experience and depict how the protagonists live in and around their apartment.</p>
      <p>Katja Jug is single author of „Frozen Unfrozen”, A Poster Novel (Edition Fink 2021), Hermes Kochbuch”, Artist's Book (Bern 2013), “Yellow”, Artist's Book (Singapur 2015), Dear Mrs. Rosenberg, Auswirkungen einer Suche nach Madonna, Artist's Book (Zürich 2004). Her work has been published among others in ARCH+, Journal for Architecture and Urbanism, FCL Magazine, Natural Ventilation Revisited, SAFARI, Projekte u. Reflexionen zur Kulturvermittlung in der Schule, LebensMittel Essen und Trinken in den Künsten und Kulturen, Diaphanes publisher.</p>
      <p>Katja Jug has participated in solo and group shows in Switzerland and abroad and has been the recipient of various grants and awards.</p>
      <p>More about the artist at:</p>
      <p><a href="https://www.katejug.net" target="_blank">https://www.katejug.net</a></p>
      <p>Mai Huyền Chi (Chi Mai) is a Vietnamese writer-filmmaker.</p>
      <p>A graduate from the MA Screenwriting program at the London Film School, she has earned writing credits for A Brixton Tale (Nominee, Best Narrative Feature, Slamdance 2021), My Mr. Wife (Winner, Best Pictures, Golden Kite Film Festival, 2018), and The Girl from Daklak (2021). Her directorial debut was the short documentary "Down The Stream" which was a finalist for Vimeo's Best of the Year in 2015. Following this documentary, Chi is developing The River Knows Our Names, her feature-length directorial narrative debut. The film is about the stateless community on the Mekong River near the Cambodia-Vietnam border and will be casting its member. The project won Far East Udine Award at Hongkong’s Film Financing Forum, traveled to Focus Asia Co-production Market (2020 Far East Film Festival), Locarno Open Doors, Bangkok ASEAN Film Festival's SEAPitch, and Singapore International Film Festival's Feature Lab. The production is set for 2023.</p>
      <p>Besides films, Chi collaborates with artists of different disciplines to produce dance films, video installations, and performative multi-media works.</p>
      <p>More about the artist at:</p>
      <p><a href="https://www.chimaian.com" target="_blank">https://www.chimaian.com</a></p>
      `,
    },
  },

  {
    id: 6,
    projectName: "... and the bacolny",
    displayName: {
      vi: "... và ban công",
      en: "... and the balcony",
    },
    artists: [
      {
        fullName: "Lê Xuân Tiến",
        country: "Vietnam",
      },
    ],
    markerOffset: 15,
    coordinates: [109.206123, 13.75966],
    medias: [
      {
        url: "https://www.youtube.com/watch?v=qHChPQWDD2g",
        videoId: "qHChPQWDD2g",
        type: "video",
        sourceType: "youtube",
      },
      {
        url: "/images/bacolny/vi/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide2.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide3.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide4.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide5.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide6.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide7.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide8.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide9.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide10.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide11.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide12.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/vi/slide13.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide2.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide3.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide4.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide5.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide6.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide7.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide8.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide9.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide10.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide11.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide12.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide13.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide14.jpg",
        type: "image",
      },
      {
        url: "/images/bacolny/en/slide15.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Năm 2018, tôi từng tham gia MAP với tác phẩm có tên “Mở cánh cửa giữa phòng ngủ và ban công”, tác phẩm bao gồm một video và một đoạn văn bản. Lúc ấy, ở ngoài ban công và trong phòng ngủ có tôi và có cảnh; tôi chỉ thấy mình tôi.</p>
      <p>Năm 2021, tôi tham gia MAP với tác phẩm có tên “… và ban công”, tác phẩm cũng bao gồm một video và một đoạn văn bản. Lúc ấy, ở ngoài ban công có tôi và có cảnh; có lẽ tôi đã cùng lúc thấy và không thấy cả tôi lẫn cảnh.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Lê Xuân Tiến sinh ngày mùng 7 tháng 2 năm 1995, hiện đang sống tại Hà Nội, Việt Nam. Năm 2017, anh tốt nghiệp chuyên ngành quay phim tại trường Đại học Sân khấu và Điện Ảnh Hà Nội. Hiện anh đang cùng bạn đi trên con đường của chúng ta hướng về Ánh Sáng.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://lxtien.wordpress.com" target="_blank">https://lxtien.wordpress.com</a></p>
      `,
      en: `<p>In 2018, I participated in MAP with a work called "Open the door between the bedroom and the balcony", which comprises a video and a text. At that time, outside on the balcony and inside the bedroom there was me and there was scenery; I only saw myself.</p>
      <p>In 2021, I participate in MAP with a work called “… and the balcony”, which also comprises a video and a text. At that time, there was me on the balcony and there was scenery; perhaps I saw and did not see at the same time both me and the scenery.</p>
      <p class="title-section">Biography</p>
      <p>Le Xuan Tien was born on February 7th, 1995; now living in Hanoi, Vietnam. In 2017, he graduated from Hanoi Academy of Theater and Cinema with a degree in Cinematography. He is currently with you on our pathway towards the Light.</p>
      <p>More about the artist at:</p>
      <p><a href="https://lxtien.wordpress.com" target="_blank">https://lxtien.wordpress.com</a></p>
      `,
    },
  },

  {
    id: 7,
    projectName: "Fifth Nocturne Op.52",
    displayName: {
      vi: "",
      en: "Fifth Nocturne Op.52",
    },
    artists: [
      {
        fullName: "Lem TragNguyen",
        country: "Germany, Vietnam",
      },
    ],
    markerOffset: 15,
    coordinates: [8.999527, 54.756101],
    medias: [
      {
        url: "https://vimeo.com/650507303",
        videoId: "650507303",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "https://vimeo.com/650507813",
        videoId: "650507813",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "https://vimeo.com/650507934",
        videoId: "650507934",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "https://vimeo.com/650507983",
        videoId: "650507983",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    displayDescription: {
      vi: `<p>Ba mẹ tôi thuộc thế hệ di cư thời sau chiến tranh. Họ gặp nhau rồi có con. Đó là những năm 90s, tôi nhớ Ba thường thâu hình mấy đứa chúng tôi bằng chiếc camera to đùng (camcorder) rồi đem ghi hết lại vô chiếc băng VHS gửi về Vietnam cho ông bà. Hồi đó, trong kí ức tuổi thơ tôi những chiếc băng kia là nội là ngoại là cô dì chú bác, là một phần gắn kết tôi đến vùng đất quê hương tôi chưa từng tới, những người thân tôi chưa từng gặp.</p>
      <p>Khi lớn lên, trong 1 dịp về Việt Nam, ở nhà bà nội tôi vô tình tìm được 1 kho đầy những cuốn băng trên đó là dòng chữ viết tay của ba tôi, ghi chú lại nội dung trong đó. Thậm chí nội còn giữ lại tuyển tập Tom & Jerry yêu thích của chúng tôi, mỗi lần mấy người ta phát trên TV ba lại bấm thâu hết vô trong một cuốn băng, thế là tôi có bộ sưu tập Tom & Jerry oách nhất mọi thời đại, tôi đã luôn từng nghĩ. Tôi suýt quên mất mình đã từng hứng khởi như thế.</p>
      <p>Sắp đặt video và âm thanh ""Fifth Nocturne Op.52"" suy ngẫm về thời gian và kí ức mà ở đó tồn tại những khoảng cách giữa các thế hệ, khoảng vắng giữa sự thật và phù du.</p>
      <p>Tác phẩm sử dụng tư liệu từ băng VHS- một thiết bị đã từng phổ biến trong mọi gia đình trong những năm 90s. Nghệ sĩ dùng những thước phim như tấm canvas của bức tranh, đưa chúng là nền (hậu cảnh) cho những phân mảnh hình ảnh, như cuộc đối thoại giữa quá khứ và hiện tại.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Lem TragNguyen được sinh ra ở Đức và lớn lên ở cả Đức và Việt Nam. Cô bắt đầu thử nghiệm với Nghệ thuật Đương đại từ năm 2017.</p>
      <p>Gần đây, cô làm việc với nhiều phương tiện khác nhau như sắp đặt, hình ảnh chuyển động, âm thanh và đặc biệt là trình diễn. Cô quan tâm đến việc chất vấn những mối quan hệ giữa cá nhân và văn hóa, những đường biên giới đầy lỗ hổng ngăn cách cái công khai với cái riêng tư, bản chất thoáng qua của các mối quan hệ con người, tính dễ biến đổi của cảm giác về nguồn cội và sự thuộc về, và một nhận thức sâu sắc về sự tạm thời, tính lưu động và sự di dời.</p>
      <p>Các tác phẩm của cô đã tham gia trong một số triển lãm và liên hoan trình diễn, bao gồm: sự kiện IN:ACT 2017 (Hà Nội), sự kiện nghệ thuật trình diễn quốc tế NIPAF 2018, Kỉ niệm 20+ của Nhà Sàn Studio (Việt Nam), Confusion is Chaos Buried bởi Tranzit (Prague) năm 2019, Series Trình diễn Wuwei (Singapore) năm 2020.</p>
      <p>Năm 2021, Lem TragNguyen sáng lập Hay là- một nền tảng tập trung vào Nghệ thuật Trình Diễn tại Việt Nam.</p>
      `,
      en: `<p>My parents are of the post-war emigrants generation. In the 90s, I remember my father used to take pictures of us with a big camercder and record it all on a VHS tape then send it back to Vietnam for my grandparents. At that time, in my childhood memories, those tapes were of paternal and maternal aunts and uncles, it was a part of connecting me with my homeland, where I had never been.</p>
      <p>Once back in Vietnam, I accidentally found a warehouse full of tapes with my father's handwritten notes on it at my grandmother's house. My grandma even kept our favorite Tom & Jerry series tape. Every time it was on TV, my dad would record it all into one tape, so I had the best Tom & Jerry collection of all time. I almost forgot how excited I was.</p>
      <p>"Fifth Nocturne Op.52" centered video installation reflecting on time and memory in which there is the distance between generations, the gap between truth and ambiguous.</p>
      <p>The work employs VHS footage though optical printing and editing, and uses them as a canvas for a painting. They are shown as the background to the image fragmentation. These overlapping movements appear as a dialogue between the past and present.</p>
      <p class="title-section">Biography</p>
      <p>Lem TragNguyen was born in Germany and grew up between Germany and Vietnam. She began experimenting with Contemporary Art since 2017.</p>
      <p>Recently, she works with various media such as installation, moving image, sound and particularly performance. She is interested in questioning the relationships between the individual and culture, the porous borders that separate the public from the private, the fleeting nature of human relationships, the mutability of our sense of origin and belonging, and an acute awareness of temporality, mobility and displacement.</p>
      <p>Her works tooks part in some exhibitions and performance festivals, including: In:act festival 2017 (Hanoi), NIPAF International 2018, 20+ Anniversary of Nhasan Studio (Vietnam), Confusion is Chaos Buried by Tranzit (Prague) in 2019, Wuwei Performance Series (Singapore) in 2020.</p>
      <p>In 2021, Lem TragNguyen founded Hay là- a platform focus on Performance Art in Vietnam.</p>
      `,
    },
  },

  {
    id: 8,
    projectName: "FACES project",
    displayName: {
      vi: "Dự án Những khuôn mặt",
      en: "FACES project",
    },
    artists: [
      {
        fullName: "Liz Adams",
        country: "US, France",
      },
    ],
    markerOffset: 15,
    coordinates: [-0.500144, 43.374382],
    medias: [
      {
        url: "/images/face0.jpeg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide2.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide3.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide4.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide5.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide6.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide7.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide8.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide9.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide10.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide11.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide12.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide13.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide14.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide15.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide16.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide17.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide18.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide19.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide20.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide21.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide22.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide23.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide24.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide25.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide26.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide27.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide28.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide29.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide30.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide31.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide32.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide33.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide34.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide35.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide36.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide37.jpg",
        type: "image",
      },
      {
        url: "/images/liz_adam/slide38.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Vượt qua các khoảng cách địa cầu, tôi đã tạo ra từ những khoảng trắng trên giấy một bộ sưu tập tranh chân dung của 38 tình nguyện viên trong dự án Lưu trú Nghệ thuật MAP. Các bức chân dung của chúng tôi kết hợp lại thành một sắp đặt gồm 38 bức vẽ riêng lẻ. Hầu hết các khuôn mặt tôi chưa từng quen biết ngoài đời. Việc được trao cho vinh dự chuyển thể những chân dung này, một hành động ký thác niềm tin từ phía các tình nguyện viên, là một trải nghiệm đẹp. Mỗi người đều có các đặc điểm, cảm xúc, tính cách độc đáo của riêng họ mà tôi đã cố gắng khai thác trong quá trình vẽ giống như một hình thức thiền về thị giác. Mặc dù các bức vẽ có thể được xem riêng lẻ, đối với tôi, sức mạnh của việc thấy chúng được nhóm lại với nhau mới thực sự là trọng tâm của dự án. Nó thể hiện một sự tôn vinh cuộc sống và nghệ thuật bất chấp những ngăn trở hiện nay trên thế giới.</p>
      <p class="title-section">Tiểu Sử</p>
      <p><a href="http://www.lizadamsart.com" target="_blank">http://www.lizadamsart.com</a></p>
      <p>Liz Adams là một nghệ sĩ người Mỹ sống tại Paris, Pháp. Các tác phẩm hội hoạ của Liz mang tính chất biểu đạt và chiêm nghiệm. Cô tập trung vào vẽ chân dung với trọng tâm là cảm xúc của chủ thể. Làm việc tại studio của mình ở Montreuil, Pháp, Liz nhận vẽ chân dung theo yêu cầu, cho các triển lãm, và đồng thời dạy một khoá học Online Mentorship Program.</p>
      `,
      en: `<p>Across global distances, I have created from the white space of paper, a collection of portrait drawings from 38 volunteers from the MAP 2021 residency.  Our portraits combined form an installation comprised of 38 individual drawings. Most of the faces are not known to me personally, but to be given the privilege to render these portraits, a vulnerable act of trust on the part of the volunteers, was a beautiful experience. Each person has their unique attributes, emotions and character that I tried to tap into during my drawing process which is a form of visual meditation. Though the drawings can be viewed individually, for me the power of seeing the group together is really the heart of the project. It represents a celebration of life and art despite the current obstacles in the world.</p>
      <p class="title-section">Biography</p>
      <p><a href="http://www.lizadamsart.com" target="_blank">http://www.lizadamsart.com</a></p>
      <p>Liz Adams is an American artist based in Paris, France. The drawings and paintings that Liz creates have an expressive and contemplative nature. Her work centers around portraiture with an emphasis on capturing the emotion of her subject. Working in her studio in Montreuil, France, Liz does commission portraiture, exhibitions and teaches an Online Mentorship Program.</p>
      `,
    },
  },

  {
    id: 9,
    projectName: "Dream Archive",
    displayName: {
      vi: "Lưu trữ giấc mơ",
      en: "Dream Archive",
    },
    artists: [
      {
        fullName: "Miho Shimizu",
        country: "Japan",
      },
    ],
    markerOffset: 15,
    coordinates: [130.793293, 29.797054],
    medias: [
      {
        url: "https://vimeo.com/653397788",
        videoId: "653397788",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "/images/dream_archive/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/dream_archive/slide2.png",
        type: "image",
      },
      {
        url: "/images/dream_archive/slide3.png",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Là một phần phần của dự án Khoảng cách trắng - MAP 2021, Miho Shimizu (Before You Dream) sẽ thu thập giấc mơ mọi người có trong các giấc ngủ trong thời gian đại dịch. Những giấc mơ được thu thập sẽ được lưu trữ online, và đọc trực tiếp tại không gian triển lãm bở các diễn viên. Các buổi đọc cho công chúng sẽ đem đến cho những giấc mơ tính trình diễn, trao tiếng nói cho những đoạn văn bản riêng tư và tạo ra một trải nghiệm chung. Ngay cả khi giấc mơ là một trải nghiệm đó hết sức riêng tư, liệu bạn có bao giờ tò mò xem liệu chúng có gì giống nhau hay không, và liệu cuộc sống trong đại dịch có ảnh hưởng tới những giấc giấc mà chúng ta có.</p>
      <p>Vào thời gian bắt đầu đại dịch, cùng với Ryuichiro Suzuki, Miho đã khởi động một dự án mang tên ‘Trước khi Bạn Mơ’. Dự án bao gồm một chương trình phát thanh, trong đó nhiều khách mời từ các lĩnh vực khác nhau đã được mời tới trò chuyện về các ý tưởng xoay quanh giấc mơ. Thành phần tham dự rất đa dạng từ nhạc sĩ, kịch sĩ, tới nhà sư… Ryuichiro bắt đầu lưu trữ các giấc mơ của chính anh dưới dạng ngôn ngữ nói và viết, cái chắp cánh cho trí tò mò của Miho, và gợi cảm hứng cho chị tổ chức dự án này.</p>
      <p>Các giấc mơ sẽ được sưu tập, lưu trữ, và trình diễn bằng tiếng Việt và tiếng Anh.</p>
      <p>Tiếng Việt: <a href="http://bit.ly/gopmong" target="_blank">http://bit.ly/gopmong</a></p>
      <p>Tài liệu liên quan đến dự án này được lưu trữ tại đây: <a href="https://issuu.com/beforeyoudream" target="_blank">https://issuu.com/beforeyoudream</a></p>
      <p class="title-section">Tiểu sử</p>
      <p>Miho Shimizu là một nghệ sĩ sống tại Tokyo. Trong vài năm trở lại đây, cô đã và đang mở rộng phương thức biểu đạt của mình thông qua việc sử dụng chất liệu dệt may; nhưng tác phẩm nằm chấp chới trong khoảng không giữa trang phục và đạo cụ của diễn viên, vũ công và nhạc công. Năm 2020, cô ra mắt xhe (trực tuyến), một tác phẩm trình diễn tương tác kỹ thuật số hợp tác với vũ công/biên đạo múa Daniek Kok. Màn trình diễn kéo dài này là một vở biên đạo chắp ghép của rất nhiều hình thức nghệ thuật — sắp đặt, múa, âm nhạc, phim — đưa các nghệ sĩ và khán giả khác nhau cùng tìm kiếm một hình tượng khó nắm bắt. Đối với Dự án XANH, chủ đề của MAP 2020, một chương trình lưu trú của Heritage Space tại Hà Nội, cô hợp tác với một nghệ nhân làm diều tại địa phương để làm những chiếc diều hình con mắt theo phong cách truyền thống Việt Nam nhằm phản ánh về cái nhìn trong đại dịch. Năm 2021 cô tham gia chương trình lưu trú tại Trung tâm Nghệ thuật Quốc tế Kinosaki, nơi cô thực hiện nghiên cứu như một cách nối dài chương trình radio Before You Dream của bản thân. Gần đây nhất, cô làm dàn cảnh sân khấu và trang phục cho tác phẩm sân khấu tạp giao フレフレ Ostrich!! Hayupang Die-Bow-Ken!. Cô từng sáng tác trong nhóm Danger Museum. <a href="http://www.dangermuseum.com" target="_blank">http://www.dangermuseum.com</a></p>
      `,
      en: `<p>As part of the residency program White Distance, Miho Shimizu (Before You Dream) will be collecting people's dreams while sleeping during the pandemic. The collected dreams will be archived online, and read live at the exhibition space in Hanoi by actors. Public reading will bring in performativity to the dreams, give a voice to a personal text and create a shared experience. It would be curious to see if there are commonalities in stories even though dreams are such an individual experience, and whether the life during the pandemic is affecting our dreams.</p>
      <p>At the start of the pandemic, together with Ryuichiro Suzuki, Miho started a project titled Before You Dream. The project included an online radio that invited guests from various disciplines to talk about the idea surrounding dreams. The variety of people they have spoken with are a musician, a playwright, a Buddhist monk to name a few. Ryuichiro started to archive the dreams he saw, which led to their curiosity in spoken and written texts, and inspired Miho to organize a public reading of dreams in this context.</p>
      <p>The dreams will be collected, archived, and performed in two languages: Vietnamese and English.</p>
      <p>English: <a href="bit.ly/beforeyoudream" target="_blank">bit.ly/beforeyoudream</a></p>
      <p>Documents related to the project will be archived here: <a href="https://issuu.com/beforeyoudream" target="_blank">https://issuu.com/beforeyoudream</a></p>
      <p class="title-section">Biography</p>
      <p>Miho Shimizu is an artist based in Tokyo. For some years, she has been expanding her means of expression through the use of textiles; pieces that float in the space between costumes, and props for actors, dancers, and musicians. In 2020 she presented xhe (online), an interactive digital performance in collaboration with a dancer/choreographer Daniek Kok. This durational performance was a choreographic bricolage of different forms – installation art, dance, music, film – bringing different artists and audiences together in search of an elusive figure. For BLUE Project, as part of MAP 2020, a residency program of Heritage Space in Hanoi, she collaborated with a local kite artisan to make traditional Vietnamese-style kites, in reflection on the gaze during the pandemic. In 2021, she took part in a residency program at Kinosaki International Arts Center where she conducted research as an extension of her radio program Before You Dream. Most recently, she has worked on scenography and costumes for a hybrid theater piece フレ フレ Ostrich!! Hayupang Die-Bow-Ken!. She has undertaken work as Danger Museum. <a href="http://www.dangermuseum.com" target="_blank">http://www.dangermuseum.com</a></p>
      `,
    },
  },

  {
    id: 10,
    projectName: "Fortune Cookies",
    displayName: {
      vi: "Bánh Quy May Mắn",
      en: "Fortune Cookies",
    },
    artists: [
      {
        fullName: "Mirimari Väyrynen",
        country: "Finland",
      },
    ],
    markerOffset: 15,
    coordinates: [25.748151, 61.92411],
    medias: [
      {
        url: "/images/airosol_particles/slide1.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide2.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide3.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide4.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide5.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide6.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide7.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide8.jpeg",
        type: "image",
      },
      {
        url: "/images/airosol_particles/slide9.jpeg",
        type: "image",
      },
      {
        url: "/images/fortune_cookies/slide1.jpeg",
        type: "image",
      },
      {
        url: "/images/fortune_cookies/slide2.jpeg",
        type: "image",
      },
      {
        url: "/images/fortune_cookies/slide3.jpeg",
        type: "image",
      },
      {
        url: "/images/fortune_cookies/slide4.jpeg",
        type: "image",
      },
      {
        url: "/images/fortune_cookies/slide5.jpeg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Chủ đề MAP 2021, Khoảng Cách Trắng, làm tôi liên tưởng tới khái niệm của sự không màu, phi vật chất, và vô chủ thể. Tôi nhìn nhận Khoảng Cách Trắng song song với sự giới hạn của các động từ cận nghĩa hoặc diễn tả chúng. Vậy nên, cho dự án này, tôi muốn tạo ra một kết nối thực thể thông qua một khách thể ăn được. Thêm nữa, tôi cố gắng thị giác hoá những khoảng trống bằng việc vẽ ghi chú cho mỗi chiếc bánh. Ngay cả khi không khí có vẻ như trong lành, một người chắc chắn đang hít vào hàng chục triệu phân tử rắn và lỏng. Chúng có thể chứa tro núi lửa, rừng cây, cát sa mạc, bụi công trình, hoặc lốp xe. Chúng là hiện thân bé nhỏ của sự vật và sự việc trên Trái Đất. Chúng trôi dạt trong bầu khí quyển từ tầng bình lưu lên bề mặt Trái Đất; và mặc dù kích cỡ nhỏ, chúng có tác động mạnh mẽ lên khí hậu và sức khoẻ của chúng ta. Mặc dù hầu hết các phân tử khí lưu lại trong không khí trong một khoảng thời gian ngắn, thường là giữa bốn ngày đến một tuần, chúng có thể di chuyển rất xa.</p>
      <p>Trong khi nướng và vẽ, sự tan vỡ, hư vô, và vô hình đã đặt cho tôi câu hỏi về khả năng quan sát. Hư không xuất hiện như một trạng thái khả thi cho những cuộc gặp gỡ, ý tưởng và cấu trúc vô định tính được hình thành. Thay vì tiên đoán, cách ngôn, hay con số may mắn, bên trong mỗi chiếc bánh quy là một vận may tiềm năng. Việc này cũng rấy lên một câu hỏi liệu rằng vận may là sự nhân từ của số phận – một thứ ta mong đợi nhận được, sự phát triển kỹ năng – một vấn đề ta có thể tự tạo ra hay đơn giản nó chỉ là một viễn cảnh?</p>
      <p class="title-section">Tiểu sử</p>
      <p>Mirimari Väyrynen sống ở Helsinki cùng gia đình. Cô tốt nghiệp khoa hội họa tại Học viện Nghệ thuật Turku (Phần Lan) năm 2001 và lấy bằng Thạc sĩ tại Đại học Aalto (Phần Lan) năm 2013. Cô còn theo học hội họa tại Học viện Nghệ thuật Quốc gia Cuba José J. Tejada ở Santiago de Cuba năm 1997–1998.Từ năm 2002 đến năm 2014 Väyrynen sống ở Tây Ban Nha và nảy sinh mối quan tâm đến mô típ cảnh quan và ý nghĩa biểu đạt về môi trường qua góc nhìn sinh thái, xã hội, và triết học. Bên cạnh việc làm nghệ thuật, cô còn có cảm thụ mãnh liệt với thiên nhiên, các nền văn hóa khác nhau, ngôn ngữ và những mẩu chuyện về cách nhìn nhận thế giới từ khi còn nhỏ. Năm 2020, Väyrynen bắt đầu theo học ngành Nhân học tại Đại học Mở Helsinki.</p>
      <p>Väyrynen thường xuyên khám phá mối quan hệ giữa con người với thiên nhiên và thế giới trong thực hành nghệ thuật của mình. Cách Väyrynen tiếp cận môi trường coi nó như là một tiến trình, là một hiện thân của các giá trị văn hóa và xã hội, nhưng lại lệ thuộc vào hiện tượng toàn cầu hóa, ô nhiễm và công nghệ. Väyrynen xuất phát từ hội hoạ. Tuy thế, cô nhận thức rằng hội hoạ có liên quan mật thiết đến không gian, thời gian và nghiên cứu. Do vậy mà cô lôi cuốn đi tìm các khả thể cho hình thức hay chất liệu của hội hoạ và khám phá những câu hỏi như hội hoạ có thể đáp ứng nhu cầu nào của con người và nó có thể sử dụng như một công cụ gì trong xã hội ngày nay. Kết hợp hội họa với các phương thức khác, cô tạo dựng các tác phẩm sắp đặt mà trở nên hoàn thiện trong không gian triển lãm.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://www.mirimari-vayrynen.com" target="_blank">https://www.mirimari-vayrynen.com</a></p>
      `,
      en: `<p>The chosen theme for MAP 2021, White Distance, referred to my mind the concepts of clinicality, immateriality and disembodiment. I perceived White Distance juxtaposing also with restriction of verbs being close to or being present with. Therefore, for the project, I wished to create a bodily connection by making an edible object. Furthermore, I attempted to give void and gap a visual form by drawing the fortune cookie notes. Even if the air looks clear, it’s almost certain that one inhales tens of millions of solid particles and liquid droplets. They might contain volcanic ash, boreal forest, desert sand, construction dust or tire wheel. They are tiny rests of activities and presences on Earth. They drift in Earth’s atmosphere from the stratosphere to the surface; and despite their small size, they have major impacts on climate and our health. Although most aerosols remain suspended in the atmosphere for short periods, typically between four days and a week, they can travel vast distances.</p>
      <p>While baking and drawing, apparent rupture, nothingness and invisibility shifted in my mind to question the capability of seeing. Void appeared as a state of possibility for yet unknown encounters, ideas and structures to emerge. Instead of prediction, aphorism or lucky number, inside of the cookies one finds a potential fortune. This is posing a question whether fortune is benevolence of destiny - something that we expect to receive, skill development - a matter we are able to produce or simply just a perspective?</p>
      <p class="title-section">Biography</p>
      <p>Mirimari Väyrynen lives in Helsinki with her family. She graduated from the department of painting in Turku Art Academy (FI) in 2001 and got her Master’s degree from Aalto University (FI) in 2013. She also studied painting at the Cuban State Arts Academy José J. Tejada in Santiago de Cuba in 1997–1998. From 2002 to 2014 Väyrynen lived in Spain where she got interested in landscape motive and of ecological, social, and philosophical significations of environment. Alongside making art, she has been extensive appreciator of nature, different cultures, languages and narratives of perceiving the world since young age. In 2020 Väyrynen started studying Anthropology in the Helsinki Open University.</p>
      <p>Recurrently Väyrynen explores human´s relationship with nature and world in her artistic praxis. Väyrynen approaches environment as a process, as an embodiment of cultural and societal values, yet subordinate to globalisation, pollution and technology. Väyrynen departs from painting. Nevertheless, she understands painting closely related to space, time and research. Hence, she is intrigued of searching possibilities for painting form or material wise and exploring questions like what human need painting might meet and what kind of tool it could be used in today´s society. Combining painting with other methods, she creates installations, which take their final form in an exhibition space.</p>
      <p>More about the artist at:</p>
      <p><a href="https://www.mirimari-vayrynen.com" target="_blank">https://www.mirimari-vayrynen.com</a></p>
      `,
    },
  },

  {
    id: 11,
    projectName: "CURE ALL",
    displayName: {
      vi: "GÌ CŨNG KHỎI",
      en: "CURE ALL",
    },
    artists: [
      {
        fullName: "Minja Gu",
        country: "Korea",
      },
    ],
    medias: [
      {
        url: "/images/minja_gu/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/minja_gu/slide2.jpg",
        type: "image",
      },
      {
        url: "https://vimeo.com/652748172",
        videoId: "652748172",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    markerOffset: 15,
    coordinates: [127.510093, 37.839852],
    displayDescription: {
      vi: `<p>Điều đó có thể xảy ra với bạn. Bạn có thấy mệt. Bạn đổ bệnh. Bạn có thể bị sốt, thấy choáng váng, buồn nôn, bị đau nửa đầu, bị nghẹt mũi và tắc mũi, hoặc chảy nước mũi, khó thở, đau họng và ho mãn tính, suy giảm chức năng phổi, cảm thấy ngạt thở, cảm thấy tim đập nhanh, tim đập mạnh bất ngờ, đau ngực hoặc đau bụng, kích ứng da hoặc phát ban, mắt bị khô hoặc đỏ hoặc cay, tiêu chảy, tê tay và chân, đau đầu gối hoặc vai, đau nhức cơ thể, đau lưỡi hoặc khô miệng, chán ăn, mất vị giác, muốn tránh nơi đông người, muốn tránh xa người khác, khó dùng bữa với người khác, cảm thấy chán nản, lo lắng, mệt mỏi, khó đọc, dán mắt vào TV hoặc điện thoại thông minh, cảm thấy nặng nề hoặc bồn chồn, mất ngủ, ngủ quá nhiều, khó thức dậy, khó mở mắt, khó ra khỏi giường , thiếu thời gian để ngủ, trải qua cảm giác khó khăn khi bước vào quán cà phê hoặc nhà hàng, chán ăn, nhạy cảm với âm thanh, nhạy cảm với xúc giác, vật lộn với công việc hàng ngày, khó tập trung, quên những gì bạn mới ăn vào bữa sáng, bối rối hoặc cảm thấy hỗn loạn, vật lộn với việc bắt đầu công việc hoặc kết thúc một cuộc họp, vật lộn với việc đi đến bưu điện hoặc ngân hàng, đột nhiên quên mật khẩu, bị căng thẳng không thể giải thích được, cảm thấy mọi thứ như buồn tẻ, cảm thấy muốn hủy cuộc họp, tâm trạng lên xuống thất thường, tăng cân quá nhiều trong một thời gian ngắn, cảm thấy kiệt quệ, thường xuyên tức giận hoặc muốn bỏ chạy.</p>
      <p>Trà trị bách bệnh (Trà Panacea) có hiệu quả trong việc xoa dịu, chữa bệnh và ngăn ngừa tất cả các triệu chứng về tâm trí và cơ thể do Covid-19 gây ra.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Minja Gu (sinh năm 1977) hiện đang sinh sống và làm việc tại Seoul, Hàn Quốc. Cô nhận bằng Cử nhân nghệ thuật chuyên ngành Hội họa của Đại học Hongik, bằng cử nhân Triết học tại đại học Yonsei và bằng Thạc sĩ Mỹ Thuật chuyên ngành Nghệ thuật thị giác của Đại Học Nghệ thuật Quốc gia Hàn Quốc. Cô từng tham gia các chương trình lưu trú tại Ssamzie Space, Hàn Quốc; Hangar, Barcelona (2008); ISCP, New York (2011); HISK, Gent, Bỉ (2015-16); và Trung tâm Sáng tạo Gyeonggi Creation, Ansan, Hàn Quốc. Sáng tác của cô được giới thiệu trong triển lãm cá nhân Những Khoảnh Khắc Giống Nhau tại Space Croft năm 2009, và các triển lãm nhóm ba gồm Triển lãm nghệ thuật lưỡng niên Đài Bắc 2008 tại Bảo tàng Mỹ thuật Đài Bắc; Giờ Sao tại Space Hamilton, Seoul; và Dự án Nghệ thuật Công cộng Anyang năm 2010. Các triển lãm gần đây của cô bao gồm: C trong Cà Ri, S trong Săm Soi tại Không gian nghệ thuật Marion de Cannier, Antwerp, Bỉ; Ai là Ai tại Waley Art, Đài Bắc (đều trong 2016); Điện Thoại Vẫn Reo Dù Thế Nào Đi Nữa tại Triển lãm lưỡng niên Moscow lần thứ 6 (2015); Một phần Câu chuyện nơi Một phần trở thành Một phần của Thứ Khác tại Witte de with, Rottemdam, Hà Lan (2014); Đánh Đổi Tương Lai tại Trung tâm nghệ thuật Đương đại Đài Bắc; Khoang trong Máy Giặt tại Trung tâm Tái chế Seodaemun-gu, Seoul (cả hai đều trong 2012); và VIDEO:VIDEO tại Bảo tàng ARKO, Seoul (2010). Năm 2018, Gu là một trong bốn nghệ sĩ được trao Giải thưởng Nghệ sĩ Hàn Quốc, một giải thưởng và triển lãm thường niên do MMCA và quỹ SBS đồng tổ chức.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="http://www.guminja.com" target="_blank">http://www.guminja.com</a></p>
      `,
      en: `<p>It can happen to you. You may feel sick. You are sick. You may have a fever, feel dizzy, have nausea, have a migraine, have a stuffy and cloggy nose, or a runny nose, have difficulty breathing, have a sore throat and chronic coughs, suffer from impairment of lung function, feel suffocated, feel your heart racing, feel unexpected heart palpitations, have chest or stomach aches, develop skin irritation or rashes, have dry or red or stinging eyes, have diarrhea, feel numbness in the hands and feet, feel pain in the knees or shoulder, have body aches, have a sore tongue or dry mouth, lose appetite, lose the sense of taste, want to avoid crowded places, want to keep away from other people, experience difficulty in having meals with others, feel depressed, feel anxious, suffer from fatigue, have trouble reading, be fixated to the TV or the smartphone, feel heavy-hearted or restless, suffer from broken sleep, suffer from too much sleep, have trouble waking up, have trouble opening your eyes, have trouble getting out of bed, lack time to sleep, experience difficulty entering a cafe or a restaurant, lose appetite, become sensitive to sound, become sensitive to touch, struggle with everyday chores, struggle with keeping focus, forget what you had for breakfast, be confused or feel chaotic, struggle with starting a task or finishing one, struggle with going to the post office or the bank, suddenly forget your password, suffer from inexplicable stress, feel like everything is dull, feel like canceling meetings, go through capricious mood swings, gain too much weight in a short period, be exhausted and burnt out, be constantly angry, or feel like running away.</p>
      <p>Cure All Tea (Panacea Tea) is effective in easing, healing, and preventing all mind and body symptoms of Covid-19.</p>
      <p class="title-section">Biography</p>
      <p>Minja Gu (b. 1977) lives and works in Seoul, Korea. She received BFA in Painting at Hongik University, a BA in Phlosophy at Yonsei University and MFA in Visual Art at Korean National University of Arts. She has participated in residencies at Ssamzie Space, Seoul; Hangar, Barcelona (2008); ISCP, New York (2011); HISK, Gent (2015-16); and Gyeonggi Creation Center, Ansan. Solo exhibitions include Identical Times at Space Croft in 2009 and group exhibitions include 08 Taipei Biennial, Taipei Museum of Fine Art; Now What, Space Hamilton, Seoul; and Anyang Public Art Project 2010. Her recent exhibitions include C as in Curry S as in Seen, Marion de Cannier Art Space, Antwerp; Who’s Who, Waley Art, Taipei (both 2016); And No Matter What The Phone Rings, 6th Moscow Biennial (2015); The Part In The Story Where A Part Becomes A Part Of Something Else, Witte de with, Rotterdam (2014); Trading Future, Taipei Contemporary Art Center; A Cabinet in the Washing Machine, Seodaemun-gu Recycling Centre, Seoul (both 2012); and VIDEO: VIDEO, ARKO Museum, Seoul (2010). In 2018, Gu was selected as one of the four sponsored artists for the Korea Artist Prize, an annual award and exhibition co-organized by MMCA and SBS Foundation.</p>
      <p>More about the artist at:</p>
      <p><a href="http://www.guminja.com" target="_blank">http://www.guminja.com</a></p>
      `,
    },
  },
  {
    id: 12,
    projectName: "supereggs",
    displayName: {
      vi: "SIÊU TRỨNG",
      en: "SUPEREGGS",
    },
    artists: [
      {
        fullName: "Quỳnh Đông",
        country: "Switzerland",
      },
      {
        fullName: "Fuyuka Shindo",
        country: "Japan",
      },
      {
        fullName: "Yeo Inyoung",
        country: "Korea",
      },
    ],
    markerOffset: 15,
    multiCoordinates: [
      [13.005623, 58.564813],
      [142.575326, 49.126467],
      [127.599582, 35.444296],
    ],
    medias: [
      {
        url: "/images/superegg/0001.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0002.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0003.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0004.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0005.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0006.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0007.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0008.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0009.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0010.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0011.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0012.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0013.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0014.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0015.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0016.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0017.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0018.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0019.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0020.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0021.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0022.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0023.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0024.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0025.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0026.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0027.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0028.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0029.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0030.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0031.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0032.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0033.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0034.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0035.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0036.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0037.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0038.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0039.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0040.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0041.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0042.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0043.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0044.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0045.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0046.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0047.jpg",
        type: "image",
      },
      {
        url: "/images/superegg/0048.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Những tác phẩm mới do cả ba nghệ sĩ làm cùng nhau có nền tảng kiến thức chung dựa trên những tư liệu của cá nhân về lịch sử địa phương dưới dạng “kể chuyện theo chu kỳ" dựa trên những vật phẩm liên quan đến “thực phẩm". Một tuyển tập những câu chuyện từ ba thế hệ phụ nữ, con gái đến mẹ và đến bà từ Hàn Quốc, Nhật Bản và Việt Nam “thổi sinh khí cho những cơ thể” quanh các thành phố và quốc gia đến Mỹ, Thuỵ Sỹ và Ireland và đi và về, là một trần thuật lưu vong và phức tạp tập trung vào việc làm thế nào mà văn hoá di cư của những người khác trở thành một phần của ta. Đây là điểm khởi đầu của chúng tôi.</p>
      <p><b>Về Supereggs:</b> một vài món ăn</p>    
      <p><b><Nuốt quả Superegg đầu tiên></b></p>
      <p>Superegg là một tập thể gồm ba nghệ sĩ nữ đến từ Châu Á. “Châu Á", “nữ", “tập thể" là những từ ngữ kỳ diệu. Nhìn vào tình hình hiện nay, có vẻ như chỉ có những từ ngữ này có thể tiếp thêm sức mạnh cho một khu vực và những con người mà bằng một cách nào đó đã bị gạt ra ngoài lề xã hội. Nhưng trong thực tế, chúng tôi có thể làm gì cùng nhau? Chúng tôi đã và đang làm việc với tư cách là những nghệ sĩ có nền tảng và cách tiếp cận tác phẩm hoàn toàn khác nhau. Tôi cảm thấy rằng chúng tôi có nhiều khoảng cách hơn điểm chung. Điều đó chứng tỏ chúng tôi không chỉ là “Châu Á" và “phụ nữ" mà chúng tôi còn tồn tại với tư cách là những con người riêng lẻ. Chúng tôi đã tiến một bước trong việc đưa những mơ tưởng về “tập thể” vào thực tế thực hành. Chẳng có cách nào để biết điều gì sẽ xảy ra tiếp theo, ngoại trừ việc tiếp tục các sự kiện, hoạt động và những câu chuyện phiếm của Superegg.</p>
      <p><最初のSuperegg を飲みこむ></p>
      <p>3人のアジア出身の女性アーティストのコレクティブ。「アジア」、「女性」、「コレクティブ」これらはマジックワードだ。昨今の情勢から、これらの要素だけで何となく周辺化されていた地域や人々をエンパワーメントできる気がする。とはいえ実際のところ、私たちは何を共に為せるのだろう。私たちは個別に全然違う背景と方法を持ってこれまでアーティストとして制作活動をしてきた。今私は共通項よりも私たち距離を感じている。それは、「アジア」と「女性」ではくくれない一人ひとりの人間として私たちが存在しているという証拠だ。とにかく、私たちは、コレクティブというファンタジーから、実践していくという現実へ一歩を踏みだした。これからどうなっていくのかはSupereggのイベントや対話を継続して活動する以外に知る術はない。</p>
      `,
      en: `<p>The new works collectively created by the three artists find common knowledge based on individual archives of local history as ‘cyclical storytelling’ based around ‘food’ objects. A collection of stories from three generations of women, daughter to mother to grandmother from Korea, Japan and Vietnam ‘animating bodies’ around different cities and countries to the US, Switzerland and Ireland and back and forth, is a diasporic and complex narrative focused on how migratory cultures of others become a part of we. This is our starting point.</p>
      <p><b>About Supereggs:</b> some dishes</p>    
      <p><b><Passing down the first Superegg></b></p>
      <p>Superegg is a collective of three female artists from Asia. ”Asia", "women" and "collective" are magic words. In the current situation, these terms seem to empower a region and people that have been somehow marginalized. But what can we actually do together? Each of us has a completely different background and approach to our work as artists. Now I feel that we have more of a distance between us than a common ground. It is proof that we are not just "Asians" and "women" but we also exist as individuals. We have taken a step from the fantasy of a “collective” to the reality of putting it into practice. There is no way to find out what will happen next, except for continuing the events, actions and banter of Superegg.</p>
      <p><첫 번째 Superegg를 삼키다></p>
      <p>3명의 아시아 출신 여성 아티스트 콜렉티브. 아시아, 여성, 콜렉티브는  매직워드다. 최근의 정세를 보면, 이러한 요소만으로 왠지 모르게 주변화 되고 있던 지역이나 사람들을 자율화 할 수 있을 것 같다.하지만 실제로 우리는 무엇을 함께 할 수 있을까. 우리는 개별적으로 전혀 다른 배경과 방법을 가지고  그동안 아티스트로서 제작 활동을 해왔다. 지금 나는 공통분모보다 우리 사이를 느끼고 있어. 그것은, 「아시아」「여성」으로 묶을 수 없는 한사람 한사람의 인간으로서 우리가 존재하고 있다는 증거다. 어쨌든 우리는 콜렉티브라는 판타지에서 실천해 나간다는 현실로 한 발 내디뎠다.  앞으로 어떻게 될 것인지는 Superegg의활동을 계속할 수밖에 알 도리가 없다.</p>
      `,
    },
  },

  {
    id: 121,
    projectName: "supereggs 2021",
    displayName: {
      vi: "Siêu trứng 2021",
      en: "Supereggs 2021",
    },
    artists: [
      {
        fullName: "Quỳnh Đông",
        country: "Switzerland, VietName",
      },
    ],
    medias: [
      {
        url: "/images/superegg_quynh_dong/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide2.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide3.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide4.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide5.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide6.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide7.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide8.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide9.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide10.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide11.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide12.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide13.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide14.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide15.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide16.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide17.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide18.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide19.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide20.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide21.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide22.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide23.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide24.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide25.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide26.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide27.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide28.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide29.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide30.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide31.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide32.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide33.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide34.jpg",
        type: "image",
      },
      {
        url: "/images/superegg_quynh_dong/slide35.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Liên quan đến thực hành nghệ thuật của mình, Quỳnh Đông sẽ đưa bạn đi trên một hành trình lịch sử nghệ thuật từ thời kỳ trung đại đến hiện nay trong tương quan với bối cảnh thông qua hai workshop.</p>
      <p><b>Workshop Tìm rau trong tĩnh vật</b></p>    
      <p>Ngày: 28/10/2021</p>
      <p>Thời gian: 2:00 - 6:00pm</p>
      <p>Người tham gia: Thảo Hoàng, Linh San, Cao Thiên Thanh, Thu Cẩm, Nguyễn Thị Kim Ngân</p>
      <p>Trong lịch sử truyền thống nghệ thuật Châu  u, tranh tĩnh vật thường mô tả các vật thể chết hoặc bất động (hoa, quả, động vật chết, kính, dụng cụ, v.v.). Chúng được lựa chọn và phân nhóm theo nội dung (thường có tính biểu tượng) và khía cạnh thẩm mỹ. Những phương thức tái hiện này đã phát triển thành một thể loại hội họa độc lập vào đầu thế kỷ 17 trong thời đại Baroque.</p>
      <p>Khi xem xét thể loại tranh tĩnh vật và sự phát triển của nó, ta cần phải đưa ra sự phân biệt giữa một thuật ngữ rộng và một thuật ngữ hẹp hơn. Tất cả những sự tái hiện của bố cục các vật thể và cách sắp xếp theo phong cách tĩnh vật đều được coi là tĩnh vật theo nghĩa rộng - đặc biệt là trước khi có sự sự hình thành của tĩnh vật như một thể loại hội hoạ vào thế kỷ 17. Khái niệm tĩnh vật theo nghĩa rộng có lẽ vẫn luôn tồn tại trong mọi thời đại và ở mọi nền văn hoá.</p>
      <p>Nghệ thuật truyền thống của Việt Nam chịu ảnh hưởng nặng nề của Trung Quốc. Việc thành lập Ecole des Beaux Arts de l’Indochine đã tạo ra một động lực mạnh mẽ cho sự phát triển của một loại hình hội họa mới. Điều này được thúc đẩy bởi hai nghệ sĩ người Pháp - Victor Tardieu (1870-1937) và cộng sự của ông Joseph Inguimberty (1896-1917) - cả hai là những người đồng sáng lập trường. Họ dạy nghệ thuật phương Tây cho sinh viên, kết hợp các kỹ thuật hiện thời (như phối cảnh, diễn tả hình ảnh ba chiều và tái hiện thực tế thông qua thị giác) và kết hợp chúng với các chủ đề, đồ vật, họa tiết, màu sắc và kỹ thuật truyền thống của Việt Nam.</p>
      <p>Thể loại tranh tĩnh vật này được các họa sĩ Việt Nam chuyển ngữ như thế nào? Tôi muốn tạo ra một workshop, nơi 10 thành viên của MAP 2021 sẽ đến thăm Bảo tàng Mỹ thuật Việt Nam tại Hà Nội để thực hiện nghiên cứu về các tác phẩm của những hoạ sĩ nổi tiếng. Họ sẽ tìm kiếm các loại rau củ quả có trong những bức tranh tĩnh vật tại bảo tàng và trong kho lưu trữ. Người tham gia sẽ chụp ảnh toàn bộ bức tranh và hình ảnh chi tiết của loại rau tìm thấy trong tranh cũng như ghi lại đầy đủ thông tin. Sau đó, những người tham gia sẽ chia sẻ những phát hiện của mình với các thành viên trong nhóm.</p>
      <p><b>Marathon sao chép tĩnh vật của Andy Warhol</b></p>
      <p>Ngày: 29/10/2021</p>
      <p>Thời gian: 2:30 - 4:00pm</p>
      <p>Người tham gia: Mai Huyền Chi, Châu, Bùi Minh Hương, Nguyễn Lê Thanh Hoàng</p>
      <p>Andy Warhol bị ám ảnh bởi việc khắc họa các đồ vật hàng ngày, cho dù là vẽ giày phụ nữ và những chiếc bánh sang trọng vào những năm 1950, in lụa các Hộp súp Campbell và Hộp Brillo vào những năm 60, hay chụp những chiếc búa, đầu lâu và thánh giá trong những năm 70 và những năm 80. Theo Warhol, những bức tranh tĩnh vật — đặc biệt là những bức tranh trưng bày những vật dụng trần tục của văn hóa tiêu dùng — có khả năng kết nối quần chúng. Ông giải thích: “Điều tuyệt vời của nước Mỹ là nó đã khởi sinh một truyền thống nơi những người tiêu dùng giàu nhất và nghèo nhất cùng mua những thứ giống nhau.“ Bạn có thể xem TV và nhìn thấy hãng Coca-Cola, và bạn biết rằng Tổng thống cũng uống coca. Liz Taylor cũng uống coca, rồi nghĩ rằng cả bạn cũng có thể uống coca."</p>
      <p>Trong nghệ thuật, sao chép được hiểu là các hình thức biểu hiện, phương pháp và biểu diễn khác nhau trong đó một hành động sáng tạo được lặp lại hoặc bắt chước.</p>
      <p>Tôi mời những người tham gia xem một bức tranh tĩnh vật của Andy Warhol và họ có thể bắt chước tái tạo lại bức tranh tĩnh vật đó trước camera máy tính. Mỗi tác phẩm sẽ được hoàn thành trong vòng 5 phút. Người tham gia sẽ được yêu cầu chụp lại tác phẩm tĩnh vật của mình bằng cách chụp màn hình và sau đó phá bỏ nó và tiếp tục cuộc marathon với tác phẩm tiếp theo.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Quỳnh Đông tạo ra những tác phẩm video cực thực nhằm cung cấp một nền tảng nội tại mà qua đó cô chủ ý thách thức các khuôn mẫu văn hóa. Thực hành của cô trải rộng đến cả trình diễn và điêu khắc. Quỳnh Đông sáng tác các tác phẩm của cô dưới dạng tranh vẽ (về mặt ý niệm). Chức năng và hình thức, nghệ thuật và sến (kitsch). Mối liên kết của sự huyễn hoặc về cái đẹp, của những giá trị tầm thường nhất.</p>
      <p>Quỳnh Đông sinh ra ở Hải Phòng, Việt Nam vào năm 1982. Cô theo học Trường Thiết kế ở Biel/Bienne để lấy bằng thiết kế đồ họa, tốt nghiệp với bằng Cử nhân Mỹ thuật tại Đại học Nghệ thuật Bern và được nhận bằng Thạc sĩ ngành Mỹ thuật tại Đại học Nghệ thuật Zurich. Cô đã hoàn thành các chương trình lưu trú tại Sommerakademie im Zentrum Paul Klee ở Bern (SAK), International Studio & Curatorial Program (ISCP) ở Thành phố New York, Rijksakademie van beeldende kunsten ở Amsterdam, MMCA Changdong điều hành bởi Bảo tàng Nghệ thuật Hiện đại và Đương đại Quốc gia, Hàn Quốc ở Seoul, và Tháng Thực hành Nghệ thuật (MAP 2019) tại Heritage Space ở Hà Nội.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://quynhdong.ch" target="_blank">https://quynhdong.ch</a></p>
      `,
      en: `<p>Relating to her art practice, Quynh Dong will take you through an art history journey of still life from the Middle Ages to the present, in relation to the prevailing contexts through two workshops.</p>
      <p><b>Workshop: Searching for vegetables in Still Life</b></p>    
      <p>Date: 28/10/2021</p>
      <p>Time: 2:00 - 6:00pm</p>
      <p>Participants: Thảo Hoàng, Linh San, Cao Thiên Thanh, Thu Cẩm, Nguyễn Thị Kim Ngân</p>
      <p>In the history of European art traditions, still life depicts the dead or inanimate objects (flowers, fruits, dead animals, glasses, instruments, etc.).They were selected and grouped according to their content (often symbolic) and aesthetic aspects. These representations developed into an independent genre of painting at the beginning of the 17th century in the Baroque era.</p>
      <p>When examining still life and its development, a distinction must be made between a broader term and a narrower one. All representations of compositions of objects and still life-like arrangements are considered still life in the broader sense — especially before the establishment of still life as a separate genre of painting in the 17th century. Still lifes in the broader sense most likely have existed at all times and in all cultures.</p>
      <p>Traditional Vietnamese art was heavily influenced by China. The establishment of the Ecole des Beaux Arts de l'Indochine gave a strong impetus to the development of a new kind of painting. This was promoted by two French artists — Victor Tardieu (1870-1937) and his collaborator Joseph Inguimberty (1896-1917) — who were both the founding directors of the school. They taught Western art to students, incorporating contemporary techniques (such as perspective, three-dimensionality and visual representation of reality) and combining them with traditional Vietnamese themes, objects, motifs, colors, and techniques.</p>
      <p>How was his painting genre of Still Life adapted by Vietnamese painters? I would like to organize a workshop where 20 members from MAP 2021’s audience will visit the Vietnam Fine Arts Museum in Hanoi to research some masterpieces. They will search for vegetables in Still Lifes, in the museum and the archive. The participants will take photos of the whole painting and write down all the information. A detailed shot of the vegetables will be needed. Afterwards the participants will share their findings with the group.</p>
      <p><b>Workshop: Copy marathon of Andy Warhol's Still Life</b></p>
      <p>Date: 29/10/2021</p>
      <p>Time: 2:30 - 4:00pm</p>
      <p>Participants: Mai Huyền Chi, Châu, Bùi Minh Hương, Nguyễn Lê Thanh Hoàng</p>
      <p>Andy Warhol was obsessed with portraying everyday objects, be it drawing women’s shoes and elegant cakes in the 1950s, printing silk screens of Campbell’s Soup Cans and Brillo Boxes in the ’60s, or taking polaroids of hammers, skulls, and crosses in the ’70s and ’80s. According to Warhol, still lifes—especially those showcasing the mundane items of consumer culture—have the ability to connect the masses. “What’s great about this country is that America started the tradition where the richest consumers buy essentially the same things as the poorest,” he explained. “You can be watching TV and see Coca-Cola, and you can know that the President drinks Coke. Liz Taylor drinks Coke, and just think, you can drink Coke, too.”</p>
      <p>In art, copying is understood to mean various forms of expression, methods, and performances, with which a creative act is repeated or imitated.</p>
      <p>I will show a picture of Andy Warhol's Still Life and the participants can copy and recreate the still life in front of the camera. The rule is that the still life will be photographed (screenshot) and then destroyed. 5 minutes is designated for each work, the next picture of still life is shown, and the marathon continues.</p>
      <p class="title-section">Biography</p>
      <p>Quynh Dong creates hyper-real video works to provide an innate platform upon which she deliberately challenges cultural stereotypes. Her practice extends to also include performance and sculpture. Dong composes her works as paintings (conceptually). Function and form, art and kitsch. Connection of the myth of the beautiful, the most trivial values.</p>
      <p>Quynh Dong was born in Hai Phong, Vietnam in 1982. She attended the Design School in Biel/Bienne for a degree in graphic design, graduated with a Bachelor of Fine Arts at the Bern University of Arts and earned her MA in Fine Arts at the Zurich University of the Arts. She completed her residency programs at The Sommerakademie im Zentrum Paul Klee in Bern (SAK), The International Studio & Curatorial Program (ISCP) in New York City, Rijksakademie van beeldende kunsten in Amsterdam, MMCA Changdong run by National Museum of Modern and Contemporary Art, Korea in Seoul and Month of Arts Practice (MAP 2019) at Heritage Space in Hanoi.</p>
      <p>More about the artist at:</p>
      <p><a href="https://quynhdong.ch" target="_blank">https://quynhdong.ch</a></p>
      `,
    },
  },

  {
    id: 122,
    projectName: "supereggs 2021",
    displayName: {
      vi: "Siêu trứng 2021",
      en: "Supereggs 2021",
    },
    artists: [
      {
        fullName: "Inyoung Yeo",
        country: "Korea",
      },
    ],
    medias: [
      {
        url: "https://vimeo.com/656582669",
        videoId: "656582669",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    displayDescription: {
      vi: `<p>“Cuộn tròn trong chiếc lưỡi của tôi” là một tác phẩm video dựa trên văn bản mà tôi đang thực hiện, nơi tôi thu thập những câu chuyện tưởng tượng về đồ ăn. Tác phẩm bắt đầu với câu hỏi, "Làm thế nào để ý tưởng về một "yoli (요리)” hoặc "món ăn "di cư từ thế hệ này sang thế hệ khác, múi giờ này sang múi giờ khác, thành phố này sang thành phố khác, ký ức này sang ký ức khác?"</p>
      <p>Câu chuyện bắt đầu từ ký ức cá nhân của tôi về “chiếc bàn của bà” với món trứng cuộn và bát mì ấm nóng đến việc làm thế nào mà câu chuyện ấy “di cư" trong ký ức của tôi đến những lớp lang khác nhau được tạo ra trong suốt quá trình “ép phẳng và lật" khi làm món trứng cuộn như một ẩn dụ cho những trần thuật đa dạng xếp chồng lên nhau. Tác phẩm tiếp tục mời gọi những người khác tham gia vào một trải nghiệm mua sắm trực tuyến trong hoạt động “Hãy cùng đi mua sắm" diễn ra tại Hà Nội và Seoul, nhựa hoá những lớp lang của tưởng tượng.</p>
      <p>Phần đầu tiên của dự án trình bày văn bản và hình ảnh được thu thập trong ấn phẩm và một video hoạt hình ngắn “Ép phẳng và Lật" </p>
      <p class="title-section">Tiểu sử</p>
      <p>InYoung Yeo là một nghệ sĩ sống và làm việc tại Seoul. Các tác phẩm của cô mở rộng từ việc cụ thể hoá văn bản, tranh vẽ và các tác phẩm sắp đặt đến các dự án giám tuyển với các cách tiếp cận liên ngành trong các chủ đề về giới, A.I. và đô thị hóa như lĩnh vực nghiên cứu chính của mình. Khám phá các mẫu dạng, con số và kích thước dựa trên đa dạng các cấu trúc và sự trùng hợp, câu hỏi của cô bắt đầu từ việc nghiên cứu các trần thuật vi mô khác nhau với trọng tâm là "mối quan hệ" theo chu kỳ. Yeo đã tổ chức và tham gia vào nhiều dự án nghiên cứu, triển lãm, chương trình lưu trú, nói chuyện và hội thảo ở Hàn Quốc, Đức, Đông Nam Á, v.v…</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://www.inyoungyeo.com" target="_blank">https://www.inyoungyeo.com</a></p>
      `,
      en: `<p>‘Curl inside my tongue’ is an ongoing text based video work, collecting stories of food fantasies. It starts with the question, ‘How does an idea of a ‘yoli (요리)’ or ‘dish’ migrate from one generation to the next, one timezone to another, one city to another, one memory to another?’</p>
      <p>The story starts from a personal memory of ‘my grandmother’s table’ with eggrolls and warm noodle soup to how the story ‘migrates’ in my memory to the different layers created throughout the ‘flatten and rotate' cooking process of an eggroll as a metaphor of diverse narratives layering on top of one another. It further invites others to an online shopping experience, ‘let’s go shopping’ activity in Hanoi and Seoul plasticizing the layers of fantasies.</p>
      <p>As the first part of the project, it presents the text and images collected in the publication and a short animation work ‘Flatten and Rotate’.</p>
      <p class="title-section">Biography</p>
      <p>InYoung Yeo is an artist based in Seoul. Her work expands from artistic materialization of text, drawing, and installation works to curatorial projects with interdisciplinary approaches in topics of Gender, A.I. and Urbanization as her main area of research. Exploring forms of patterns, numbers and dimensions based on various structures and coincidences, her questions start from researching differing micro-narratives with a  focus on the cyclical ‘relation’. Yeo has put together and participated in various research projects, exhibitions, residencies, talks, and workshops in Korea, Germany, Southeast Asia, among others.</p>
      <p>More info about the artist at:</p>
      <p><a href="https://www.inyoungyeo.com" target="_blank">https://www.inyoungyeo.com</a></p>
      `,
    },
  },
  {
    id: 123,
    projectName: "supereggs 2021",
    displayName: {
      vi: "Siêu trứng 2021",
      en: "Supereggs 2021",
    },
    artists: [
      {
        fullName: "Fuyuka Shindo",
        country: "Japan",
      },
    ],
    medias: [
      {
        url: "/images/supereggs_fuyuka/300cm.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/A1.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/A2.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/A3.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/A4.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/A5.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/A6.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B1.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B2.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B3.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B4.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B5.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B6.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B7.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B8.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B9.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B10.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B11.jpg",
        type: "image",
      },
      {
        url: "/images/supereggs_fuyuka/B12.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Các câu khảo sát dựa trên những điều tôi vẫn thường hỏi mọi người và những điều tôi muốn biết trong dự án làm về cà phê.</p>
      <p>Đồ ăn và đồ uống chung nhất của “chúng ta” là gì? Câu hỏi này khởi đầu cho dự án của tôi.</p>
      <p>Đồ ăn chung là loại thực phẩm quen thuộc với tất thảy chúng ta, dù ở bất cứ nền văn hoá hay là người nước nào. Chúng ta có thể kể một vài câu chuyện về đồ ăn đó, chẳng hạn như kỷ niệm của riêng mình hay công thức nấu ăn của gia đình. Tôi thấy có chút lạ lẫm khi tôi nhận diện cụm từ “mọi người đều có thể kể” này. Đằng sau đồ ăn, có những câu chuyện về chính trị thế giới, kinh tế, lịch sử của nhóm thống trị, và sự phát triển công nghệ. Tôi thấy thú vị một điều rằng đồ ăn chung thì có cả khía cạnh cá nhân lẫn xã hội.</p>
      <p>Lần nay tôi chọn cà phê là thực phẩm chung của “chúng ta”, bơi tôi là một người yêu thích cà phê và Việt Nam là một trong những trung tâm sản xuất ra hạt cà phê.</p>
      <p>Đây là một dự án vẫn đang được thực hiện và cho đến nay các hoạt động chủ yếu là nghiên cứu, ví dụ như bản khảo sát trực tuyến hỏi mọi người về cách thức sinh hoạt của họ với cà phê, một bài giảng về cà phê ở Trung Nguyên, cũng như các công trình nghiên cứu và báo cáo về ngành cà phê địa phương ở Việt Nam do nhóm tình nguyện viên thực hiện.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Fuyuka Shindo là một nghệ sĩ sinh ra và làm việc tại Sapporo, Nhật Bản. Cô đã và đang tạo ra các tác phẩm liên quan đến lịch sử, văn hóa và thiên nhiên xung quanh khu vực "địa phương", dựa trên kinh nghiệm và nghiên cứu của bản thân. Trong những năm gần đây, cô đã phát triển một loạt các hoạt động bao gồm các tour và các trình diễn bên-ngoài nhằm làm sáng tỏ lịch sử ẩn giấu và các vấn đề của khu vực địa phương, đồng thời khuyến khích khán giả xem xét các vấn đề đó. Cô đã tham gia vào các dự án, triển lãm và chương trình lưu trú trong nước và quốc tế. Cô từng tham gia MAP với tư cách là một nghệ sĩ vào năm 2019, và cùng với InYoung Yeo và Quỳnh Đông, cô sẽ tiếp tục tham gia MAP 2021 lần này như một phần của nhóm Superegg.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://www.shindofuyuka.com" target="_blank">https://www.shindofuyuka.com</a></p>
      `,
      en: `<p>These questions are based on what I have asked people and what I have wondered during the project on coffee.</p>
      <p>What are ‘our’ most common foods and drinks? That is the start of my project.</p>
      <p>Common foods are familiar to all of us over our culture and nationality. We all can tell some stories about them, such as personal memories and family recipes. I feel a bit strange when I recognize this ‘everyone can tell’. Behind it, there are stories of world politics, economy, history of hegemony and progress of technology. It is interesting for me that common foods have both personal and social aspects.</p>
      <p>This time I chose coffee as ‘our’ common food, because I am a coffee lover and Vietnam is one of the centers to produce coffee beans.</p>
      <p>It is an ongoing project and so far the activities were mainly research, such as an online survey to question how people live with coffee, a lecture about coffee in Central Highland, as well as research and reports about local coffee businesses in Vietnam by a volunteer team.</p>
      <p class="title-section">Biography</p>
      <p>Fuyuka Shindo is an artist born and based in Sapporo, Japan.  She has been creating works related to the history, culture and nature around the "local " area, based on her own experiences and research. In recent years she has developed a range of activities including tours and out-of-door performances that illuminate the hidden histories and issues of the local area and encourage audiences to consider the issues. She has participated in national and international projects, exhibitions and residencies. She joined MAP as an artist in 2019, and together with InYoung Yeo and Quynh Dong, is taking part in MAP2021 as part of Superegg this time.</p>
      <p>More info about the artist at:</p>
      <p><a href="https://www.inyoungyeo.com" target="_blank">https://www.inyoungyeo.com</a></p>
      `,
    },
  },
  // {
  //   id: 13,
  //   projectName: "White Distance - Beuys 100",
  //   artists: [
  //     {
  //       fullName: "Quynh Lam",
  //       country: "Vietnam",
  //     },
  //   ],
  //   markerOffset: 15,
  //   coordinates: [105.804817, 21.028511],
  // },
  {
    id: 14,
    projectName: "Negotiating Distance as Collective Healing",
    displayName: {
      vi: "Cuốn sách của sự Chữa lành Tập thể",
      en: "The Book of Collective Healing",
    },
    artists: [
      {
        fullName: "Ruchika Wason Singh",
        country: "India",
      },
    ],
    markerOffset: 15,
    coordinates: [76.127472, 26.860432],
    medias: [
      {
        url: "/images/ruchika/slide01.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide02.jpg",
        type: "image",
      },
      {
        url: "https://vimeo.com/650157546",
        videoId: "650157546",
        type: "video",
        sourceType: "vimeo",
      },
      {
        url: "/images/ruchika/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide2.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide3.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide4.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide5.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide6.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide7.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide8.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide8a.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide9.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide10.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide11.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide12.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide13.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide13a.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide14.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide15.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide16.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide17.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide18.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide19.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide20.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide21.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide22.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide22a.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide23.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide24.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide25.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide26.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide27.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide28.jpg",
        type: "image",
      },
      {
        url: "/images/ruchika/slide30.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Cuốn sách của sự Hàn gắn Tập thể là một hành trình của sự thấu cảm, cộng tác và chia sẻ. Bằng việc kéo gần khoảng cách trong thời kỳ covid và lấp đầy nó bằng những sắc màu cuộc sống. Cuốn sách được gợi cảm hứng từ xu hướng của con người vốn là một loài động vật xã hội và có nhu cầu xây dựng các mối liên kết đã mất. Nó tìm kiếm trong thực hành nghệ thuật và trong ngôn ngữ thị giác một nguồn lực cho việc tạo dựng sự đoàn kết qua các miền địa lý.</p>
      <p>Bốn nghệ sĩ từ bốn phần khác nhau của thế giới quyết định đến với nhau trong hành trình này thông qua một dự án sách lưu chuyển. Cuốn sách cuộn là một tác phẩm nghệ thuật có chiều dài 6 feet (182cm), tượng trưng cho khoảng cách 6 feet được người Ấn Độ duy trì, như một quy ước thời covid. Nghệ sĩ đã sử dụng “khoảng cách trắng”  mang hàm ý tượng trưng trên nền giấy trắng, và vượt qua khoảng cách này (sẽ là bất khả nếu không) thông qua một tác phẩm nghệ thuật.</p>
      <p>Cuốn sách cuộn di chuyển qua bốn địa điểm trên hai châu lục. Ở mỗi điểm đến, nó mở ra một địa hạt để phản ánh những trải nghiệm thời covid và của quá trình thanh lọc cảm xúc.  Khởi hành từ Delhi, cuốn sách chu du tới Sapporo; tìm đường đến Zurich, sau đó tới Dresden và cuối cùng hoàn thiện vòng tròn trở về Delhi.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Ruchika Wason Singh là một nghệ sĩ thị giác, giảng viên, và người nghiên cứu độc lập tại Delhi, Ấn Độ. Bà nhận bằng Cử nhân Nghệ thuật (1997) và Thạc sĩ (1999) chuyên ngành Hội Hoạ tại trường College of Art, New Delhi. Năm 2008, bà hoàn thành nghiên cứu tiến sĩ chuyên ngành Lịch sử nghệ thuật tại trường University of Delhi. Nghiên cứu này được hỗ trợ bởi quỹ Junior Research Fellowship danh giá từ University Grants Commission, một quỹ chính phủ Ấn Độ (2001 - 2006).</p>
      <p>Tác phẩm của Ruchika được trưng bày cá nhân và triển lãm nhóm rộng rãi tại khu vực Nam Á, Đông Nam Á, Đông Á và Châu  u. Bà cũng tham gia các chương trình lưu trú quốc tế tại Sri Lanka, Hàn Quốc, và Việt Nam. Thực hành nghệ thuật của bà trong thời điểm hiện tại chú tâm vào vấn đề môi trường qua góc nhìn nhân sinh. Được phát triển dần qua các chương trình lưu trú nghệ thuật, tác phẩm của Ruchika sử dụng mực sumi-e trên chất liệu giấy tự làm đa dạng, như xuan, washi, Hanji và dó.</p>
      <p>Năm 2016, Ruchika triển khai A.M.M.A.A - The Archive for Mapping Mother Artists (Bản Đồ Lưu Trữ các Nghệ Sĩ-Mẹ Châu Á), một dự án nghiên cứu về mẹ trong nghệ thuật. Bà đã giảng dạy tại trường College of Art và Đại học Ashoka ở Ấn Độ. Sáng tác của bà được xuất bản tại Artnow Pakistan, Demeter Press (Canada), Routledge (Anh Quốc), Lalit Kala Contemporary và Indian Creative Minds.</p>
      `,
      en: `<p>The Book of Collective Healing is a journey of empathy, collectivity and sharing. Of bringing the distances during covid times closer and filling it with the colours of life. The book is inspired by the human tendency to be a social animal and the need to build lost connections. It seeks artistic practice and the visual language as a resource for building solidarity across geographies.</p>
      <p>Four artists in different parts of the world decided to come together on this journey through a travelling book project. The folding book is six feet long work of art, is symbolic of the six feet social distance maintained by people in India, as a covid protocol. The artists have symbolically used this ‘white distance’ in the white of the paper, and traversed this distance (otherwise not possible) in a work of art.</p>
      <p>The folding book travelled across four destinations and two continents. At every destination , the book evolved as a site for reflection on covid experiences and that of purging of emotions. Starting from Delhi, the book travelled to Sapporo; making its way to Zurich, thereafter to Dresden and finally making a full circle, returned to Delhi.</p>
      <p class="title-section">Biography</p>
      <p>Ruchika Wason Singh a visual artist, art educator and independent researcher based in Delhi,India. She completed B.F.A. (1997) and M.F.A.(1999) with specialisation in painting from College of Art, New Delhi.This was followed by doctoral research in art history at the University of Delhi (2008)in 2008. The research was supported by the prestigious Junior Research Fellowship from University Grants Commission, Government of India (2001-2006).</p>
      <p>Ruchika has widely exhibited in solo and group exhibitions in South Asia, South -East Asia, East Asia and Europe. She has also participated in international artist residency programs in Sri Lanka , South Korea and Vietnam. Her current artistic practice primarily focuses on environment through the lens of human habitation. Her works are informed by the use of different handmade papers,  such as xuan, washi, Hanji and dzo to create works in sumi-e ink; which she as slowly developed, through her international artistic exchange participations.</p>
      <p>In 2016, she initiated A.M.M.A.A.- The Archive for Mapping Mother Artists in Asia, a project facilitating maternal research in art. She has taught at College of Art and Ashoka University in India. Her writings have been published in Artnow Pakistan, Demeter Press (Canada), Routledge (U.K.), Lalit Kala Contemporary and Indian Creative Minds amongst others.</p>
      `,
    },
  },

  {
    id: 15,
    projectName: `“Zooming In the Ghost: Making a Ghost as International Misunderstanding” (Tentative title)`,
    displayName: {
      vi: "Phóng Chiếu Bóng ma",
      en: "Zooming In the Ghost",
    },
    artists: [
      {
        fullName: "Ryusuke Ito",
        country: "Japan",
      },
    ],
    medias: [
      {
        url: "https://www.youtube.com/watch?v=ThnyHDv9skA",
        videoId: "qHChPQWDD2g",
        type: "video",
        sourceType: "youtube",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto01.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto02.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto03.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto04.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto05.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto06.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto07.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto08.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto09.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto10.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto11.jpg",
        type: "image",
      },
      {
        url: "/images/ryusuke_ito/ItoPhoto12.jpg",
        type: "image",
      },
    ],
    markerOffset: 15,
    coordinates: [143.158597, 46.084008],
    displayDescription: {
      vi: `<p>Bộ phim được thực hiện và lấy cảm hứng từ câu chuyện ma trong một cuốn sách trẻ em xưa của Nhật Bản, truyện đề cập đến chiến tranh Việt Nam những năm 1970. Năm mươi năm trước, KHÔNG có mạng; trong hoàn cảnh mọi người đi lại còn khó khăn và thậm chí không thể gọi điện tới Việt Nam từ Nhật Bản, tác giả cuốn sách đã tận dụng khoảng cách này để dựng nên câu chuyện kinh dị lấy bối cảnh chiến tranh Việt Nam; một sự khai thác thảm kịch của đất nước này. Tuy nhiên, thời gian trôi đi, qua nhiều thế hệ, chiến tranh và ký ức của nó ngày càng xa khuất, những chứng tích lịch sử đã mất, giờ đây chúng ta không còn cách nào để xác nhận câu chuyện đó thật hay giả; câu chuyện tự nó đã trở thành một bóng ma văn hóa.</p>
      <p>Ngày nay, dưới kỷ nguyên COVID-19, chúng ta hầu như không gặp gỡ bạn bè, và chỉ gặp nhau qua mạng bằng việc dùng các ứng dụng như ZOOM. Bạn của tôi trên màn hình có hình dáng và giọng nói của họ, nhưng chúng tôi không thể chạm, ngửi hay gần gũi nhau; bây giờ tôi cảm thấy như thể tất cả mọi người đều trở thành những bóng ma.</p>
      <p>Trong dự án (phim) này, tôi mong muốn tái hiện lại câu chuyện ma năm xưa với những người bạn ma ở phương xa.</p>
      <p class="title-section">Tiểu Sử</p>
      <p>Ito Ryusuke là một nghệ sĩ thị giác, nhà làm phim người Nhật, còn được biết đến như một nhà phê bình văn hóa đại chúng với bút danh Kenji Murasame. Ông sinh năm 1963 tại Hokkaido. Ito Ryusuke tốt nghiệp Cử nhân Nghệ thuật ngành Thiết kế Đồ họa ở Đại học Zokei Tokyo năm 1988 và Thạc sỹ Nghệ thuật của Học viện Nghệ thuật Chicago, chuyên ngành Làm phim vào năm 1992. Lấy video làm  chất liệu sáng tác, các tác phẩm sắp đặt của Ito tập trung và các chủ đề về sự sản sinh ký ức cũng như nhận thức hình ảnh thông qua các phương tiện truyền thông thị giác ngày nay. Ông đã có rất nhiều triển lãm tại các bảo tàng và phòng triển lãm trên khắp Nhật Bản và các nước châu Á khác. Ông hiện đang sống ở thành phố Sapporo, Nhật Bản và giảng dạy tại Đại học Sư phạm Hokkaido.</p>
      `,
      en: `<p>The film was made and inspired by the ghost story in an old Japanese children book mentioning the Vietnamese War in the 1970th. 50 years ago, there was NO internet; in environment, which people could hardly go nor even telephone to Vietnam from Japan, the author of the book took advantage of this distance to make up horror story taking a place in the War; it was an exploitation of this countries' tragedy. However, as time pass by, citizens change their generations, the war and its memories were far and far, and historical evidences are lost, we now don't have any way to confirm even the story was true nor fake; the story itself became a cultural ghost.</p>
      <p>Today, under the COVID-19 era, we hardly meet our friends, and only see each other through the internet by using applications like ZOOM. My friend on screens have their figures and voices, but we can not touch, smell nor hold each other; I now feel as if all humans became ghosts.</p>
      <p>In this project (film), I would like to recreate the old ghost story with my fellow ghosts in far distance.</p>
      <p class="title-section">Biography</p>
      <p>Ito Ryusuke is a Japanese Visual Artist / Filmmaker, also known as Kenji Murasame, a critic for Japanese pop culture. He was born in Hokkaido, Japan in 1963. Ito Ryusuke graduated from Tokyo Zokei University with a BFA in visual design, in 1988 and graduated from The School of the Art Institute of Chicago with an MFA in Filmmaking, in 1992. Using video media, Ito produces video installations dealing with the themes of the generation of memories as well as the visual recognition through nowadays’ visual media. Ito Ryusuke has had several gallery and museum exhibitions around Japan and ASIAN countries. Ito Ryusuke lives in Sapporo, Japan and teaches at The Hokkaido University of Education now.</p>
      `,
    },
  },

  {
    id: 16,
    projectName: "White Noise (From A Distance)",
    displayName: {
      vi: "Nhiễu Trắng (Từ Xa)",
      en: "White Noise (From a Distance)",
    },
    artists: [
      {
        fullName: "Till Ansgar Baumhauer",
        country: "Germany",
      },
    ],
    markerOffset: 15,
    coordinates: [10.451526, 51.165691],
    medias: [
      {
        url: "/images/till_ansgar/till_0.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/till_1.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/till_2.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/till_3.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/till_4.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/till_6.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/till_7.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/triple_carpet_1.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/triple_carpet_2.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/website_3.jpg",
        type: "image",
      },
      {
        url: "/images/till_ansgar/wool5.jpg",
        type: "image",
      },
    ],
    displayDescription: {
      vi: `<p>Điểm xuất phát cho suy ngẫm của tôi về chủ đề MAP năm nay là màu trắng như một chỉ thị cho một thứ thiếu vắng – không gian rỗng không xác định để chỉ ra một khoảng trống, sự thiếu hụt hoặc quá tải thông tin (như trong "tiếng ồn trắng" trên TV thời thơ ấu của tôi hay trong âm thanh hay trong sự pha trộn của các ánh sáng màu khác nhau dẫn đến ánh sáng trắng).</p>
      <p>Theo quan điểm này, trắng không chỉ ra một sân chơi sáng tạo để được lấp đầy bởi các cử chỉ và / hoặc màu sắc, mà chỉ tới thông tin không thể tiếp cận được, dẫu là kiến thức dựa trên hình ảnh hay văn bản.</p>
      <p>Và chính sự thiếu sót kiến thức này được nhận thức bởi người xem và do đó tạo ra khoảng cách giữa người xem và vật thể / thông điệp / ý nghĩa. Màu trắng vì thế cũng là một công cụ kiểm duyệt một cách rộng rãi nhất.</p>
      <p>Ý niệm về tác phẩm trưng bày của tôi được tạo ra ngay sau khi quân đội quốc tế rút khỏi Afghanistan tháng 8/2021. Gần như từ ngày này sang ngày khác, một hệ thống chính quyền nhà nước sụp đổ, và cùng với quân đội của liên minh ISAF, lợi ích của công chúng cũng rời bỏ đất nước, nhường chỗ cho những phỏng đoán và sự thiếu hụt thông tin.</p>
      <p>Từ những năm 1980, cái gọi là “thảm chiến” từ Afghanistan lan truyền khắp thế giới (nghệ thuật), trưng bày hình tượng vũ khí và võ thuật thay vì các hoa văn và trang trí truyền thống. Là chứng tích cá nhân thời chiến thuở ban đầu, những tấm thảm này đã trở thành vật buôn bán rập khuôn trong suốt hai mươi năm qua. Sử dụng một tấm “thảm chiến" sản xuất hàng loạt như vậy từ Afghanistan, tôi tái hiện sự mất mát của kiến thức và thông tin,  cũng như của ký ức tập thể; thắt từng nút một và bằng tay, tôi gỡ len ra khỏi thảm, phân loại theo màu sắc, cho đến khi chỉ còn lại màu ngà nền. Quá trình này mang tính thiền định nhưng cũng diễn ra khi thảo luận (trực tuyến với bạn bè ở các quốc gia khác) về các chủ đề như bản sắc dân tộc, tình hình người  ngoại quốc và các khía cạnh về giao tiếp xuyên quốc gia.</p>
      <p>Thông tin dệt vào tấm thảm do đó mất đi, và lớp vải đen trắng cơ sở xuất hiện bên dưới - nhiễu trắng thay vì thông tin hình ảnh. Ảnh in trên thảm chụp lại trong quá trình tháo gỡ lông cừu (một bức ảnh sau khi gỡ bỏ hoàn toàn một màu) cũng tạo ra một khoảng cách thị giác giữa vật thể ban đầu và người xem trong triển lãm.</p>
      <p class="title-section">Tiểu sử</p>
      <p>Till Ansgar Baumhauer tiếp cận thực hành nghệ thuật từ góc nhìn mang tính ý niệm. Chính vì vậy, sự đa dạng về mặt chất liệu và công cụ thị giác được anh sử dụng phản ánh các chủ để mà anh đang hướng tới. Mỗi chất liệu được sử dụng đều có một chức năng hoặc ý nghĩa riêng trong quá trình nghiên cứu và sáng tạo của nghệ sĩ. Một trong những đề tài chính được Baumhauer tập trung khắc họa trong nhiều năm qua là vấn đề bạo lực và câu hỏi làm thế nào để biến đổi về mặt thị giác và tinh thần của khái niệm này. Chẳng hạn, luận án tiến sĩ của anh nghiên cứu về những cách khắc họa bạo lực chiến tranh kéo dài và minh chứng cụ thể ở hai cuộc chiến có vẻ rất khác nhau - Chiến tranh Ba Mươi Năm diễn ra cách đây 400 năm tại Đức và xung đột hiện tại ở Afghanistan. Việc so sánh và lấy mẫu từ các nền văn hóa thị giác của cả hai cuộc xung đột tạo ra một loạt các tác phẩm nghệ thuật giải quyết vấn đề về khả năng chuyển dịch của kí ức giữa các nền văn hóa.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="http://www.till-ansgar-baumhauer.com" target="_blank">http://www.till-ansgar-baumhauer.com</a></p>
      `,
      en: `<p>Starting point for my reflection on this year‘s MAP topic is the colour white as an indicator of something missing – the blank undefined space would indicate a gap, the lack or the overload of information (like in the „white noise“ on the TV of my childhood or in sound or in the mixing of different coloured lights leading to white light).</p>
      <p>From this viewpoint, whiteness does not indicate a creative playground to be filled with gestures and / or colour, but rather unapproachable information, be it visual or text-based knowledge.</p>
      <p>And exactly this lack of knowledge is perceived by the viewer and therefore creates a distance between viewer and object / message / meaning. White is therefore also a tool of censorship in the broadest way.</p>
      <p>The concept of my work on display was created immediately after the withdrawal of international troops from Afghanistan in August 2021. Almost from one day to the next, a state government system collapsed, and with the troops of the ISAF alliance, public interest also left the country, giving way to projections and lack of information.</p>
      <p>From the 1980s, so-called “war rugs” from Afghanistan spread through the (art) world, displaying weaponry and martial imagery instead of traditional patterns and ornaments. Individual wartime testimonies in the beginning, these rugs became streamlined trade objects during the last twenty years. Using such a mass-produced "war rug“ from Afghanistan, I re-enact the loss of knowledge and information, but also of collective memory; knot by knot and by hand, I remove the wool from the carpet, sorted by colour, until only the ivory background colour remains. The process is meditative but also happens while discussing (online with friends in other countries) topics like national identity, the situation of expats and aspects of transnational communication.</p>
      <p>Information woven in the rug is thus lost, and the black and white basic fabric appears underneath - white noise instead of visual information. Printed images of the carpet taken during the process of removal of wool (one photo after completely removing one colour) also create a visual distance between the original object and the viewer in the exhibition.</p>
      <p class="title-section">Biography</p>
      <p>Till Ansgar Baumhauer’s artistic strategies come from a conceptual viewpoint. Thus, the variety of materials and visual tools he uses refer to the topics he works on. Each artistic material he uses refers to a function or meaning in the artistic and research processes he is following. One of Baumhauer ’s main topics for years has been the depiction of violence and the question of how it can be transformed visually as well as mentally. His Ph.D., for example, was an investigation on the depiction of long-term war violence and its depiction in two seemingly very different conflicts - the Thirty Years War in Germany four hundred years ago, and the contemporary conflict in Afghanistan. A comparison and sampling of the visual cultures of both conflicts led to a series of artworks dealing with the translatability of memory from one culture to the other.</p>
      <p>More about the artist at:</p>
      <p><a href="http://www.till-ansgar-baumhauer.com" target="_blank">http://www.till-ansgar-baumhauer.com</a></p>
      `,
    },
  },

  {
    id: 17,
    projectName: "Indirect Travel",
    displayName: {
      vi: "Du lịch gián tiếp",
      en: "Indirect travel",
    },
    artists: [
      {
        fullName: "Shiori Higashiyama",
        country: "Japan",
      },
    ],
    markerOffset: 15,
    coordinates: [131.840305, 32.568718],
    medias: [
      {
        url: "/images/indirect_travel/01_shiori.jpg",
        type: "image",
      },
      {
        url: "/images/indirect_travel/02_shiori.jpg",
        type: "image",
      },
      {
        url: "/images/indirect_travel/03_shiori.jpg",
        type: "image",
      },
      {
        url: "/images/indirect_travel/04_shiori.jpg",
        type: "image",
      },
      {
        url: "/images/indirect_travel/05_shiori.jpg",
        type: "image",
      },
      {
        url: "/images/indirect_travel/06_shiori.png",
        type: "image",
      },
      {
        url: "/images/indirect_travel/07_shiori.jpg",
        type: "image",
      },
      {
        url: "https://vimeo.com/650048308",
        videoId: "650048308",
        type: "video",
        sourceType: "vimeo",
      },
    ],
    extraDescription: `<p><a href="https://postcards.shiorihigashiyama.com/drawings" target="_blank">https://postcards.shiorihigashiyama.com/drawings</a></p>`,
    displayDescription: {
      vi: `<p>Trong dự án MAP này, các nghệ sĩ kết nối trực tuyến hàng tuần. Trong các cuộc họp Zoom, mặc dù chênh lệch múi giờ, tôi không thể cảm thấy được khoảng cách vật lý vốn có giữa mọi người từ các quốc gia và địa điểm khác nhau.</p>
      <p>Sẽ ra sao nếu tôi có thể lưu trú ở Việt Nam như kế hoạch ban đầu của chương trình lưu trú, dẫu khả năng di chuyển của tôi bị hạn chế bởi covid? Tôi mường tượng trải nghiệm mà tôi sẽ có được khi di chuyển. Có lẽ tôi đã có thể có được trải nghiệm di chuyển quanh một vùng đất xa lạ và học hỏi từ người dân địa phương về những điều độc đáo của vùng đất đó, hoặc sống giữa những người bản địa ở một nơi hoàn toàn mới đối với tôi.</p>
      <p>Vì thế tôi hỏi: "Nếu tôi đến thăm quê hương bạn, bạn có gợi ý gì về địa điểm, hàng quán nơi khu vực bạn sống không? Và nhờ người người từ các quốc gia khác nhau gửi tôi ảnh và đánh giá về khu vực họ sống. Dựa trên thông tin này, tôi tìm kiếm những địa điểm tương tự ở Nhật Bản, di chuyển trong Nhật Bản để đến đó và chụp lại chúng.</p>
      <p>Trong khi thực hiện dự án này, tôi cảm nhận được sự gián đoạn giữa những khoảng cách rất xa giữa chúng ta với việc được nghe những câu chuyện bản địa mang tính riêng tư, và một cách tự nhiên nó làm cho tôi nghĩ đến “việc di chuyển”.</p>
      <p>Có một từ là “Yo-haku”, được viết là "余 白" trong chữ Hán (白-Haku-Bạch có nghĩa là Trắng /Khoảng trống/Trống rỗng, đứng bên cạnh ký tự 余-Yo-Dư có nghĩa là phần còn lại/phần dư). Từ “Yo-haku” có nghĩa là "khoảng trống, “khoảng trống còn lại" hoặc “khoảng trống dư”. Đối với tôi, chủ đề “Khoảng Cách Trắng” của MAP làm tôi nghĩ đến từ "Yo-haku.”</p>
      <p>Trong dự án này, thay vì thực sự đến thăm được tận nơi địa điểm nào đó, tôi đã được mọi người giới thiệu và chia sẻ về địa điểm cũng như những mẩu chuyện cá nhân của mình, nhờ vào đó tôi đã được nếm chút hương vị cuộc sống của nhiều người. Đổi lại việc di chuyển, tôi tin rằng mình đã thu được một khoảng trống trong trái tim và tâm trí để có thể hình dung ra những khoảng cách rộng lớn.</p>
      <p class="title-section">Tiểu Sử</p>
      <p>Shiori Higashiyama là họa sĩ hiện đang sống và làm việc tại Tokyo, Nhật Bản. Cô sinh năm 1990 tại Hyogo, và tốt nghiệp cử nhân Hội họa, Đại học Nghệ thuật Tokyo năm 2016. Mối quan tâm của Shiori chủ yếu tập trung vào sự diễn dịch sai lệch về từ ngữ, hội thoại, và ngôn ngữ. Cô tạo ra những tác phẩm hai chiều sử dụng từ ngữ và hình ảnh được vẽ trên các bản nhật ký, ghi chép và hiện tượng cá nhân. Cô cũng quan tâm tới hội họa và sáng tác tranh như một phương tiện cho sự hiểu.</p>
      <p>Tìm hiểu thêm về nghệ sĩ tại:</p>
      <p><a href="https://shiorihigashiyama.com/paintings" target="_blank">https://shiorihigashiyama.com/paintings</a></p>
      `,
      en: `<p>In this MAP project, the participating artists were connected online every week. In the Zoom meetings, despite the time differences, I could not feel the real physical distance between us- who are from different countries and locations.</p>
      <p>I wondered what if I had been able to visit and stay in Vietnam as planned in the original residency program, even though my mobility was restricted by covid? I imagined the experience I would have gained by moving. I could have been able to have the experience of moving through a strange land and learning from the local people about unique local things about that place, or living among the locals in a place that was new to me.</p>
      <p>So I asked, "If I were to visit your hometown, do you recommend any shops or places in your neighborhood?, and asked people from different countries to send me photos and reviews of their places. Based on this information, I searched for similar places in Japan and traveled within Japan to those places and took photos of them.</p>
      <p>This project made me feel the gap between very great distances between us and hearing personal local stories, and naturally made me think about “to move”.</p>
      <p>There is a word “Yo-haku”, which is written as "余白" in Chinese characters. The character “白(Haku)”, which means White/ Blank/Empty, stands next to the character “余(Yo)”, which means remainder/the rest/more than. Altogether, the word “Yo-haku” means  free space, remaining blank space. The theme of MAP this year "The White Distance" brought to my mind the word "Yo-haku".</p>
      <p>In this project, instead of actually being able to visit the place, by being introduced and shared by people about their places and personal episodes, I was able to get a little taste of the lives of many people. In exchange for moving around to travel to the places, I believe that I gained free space in my heart and my mind to imagine vast distances.</p>
      <p class="title-section">Biography</p>
      <p>Shiori Higashiyama is a painter based in Tokyo, Japan. She was born in 1990 in Hyogo, Japan, and graduated from Tokyo University of the Arts in 2016 with a BFA in Painting. Shiori's key focus is on the misinterpretation of words, conversations, and language, and she creates two-dimensional works using words and images drawn from personal journals, records, and phenomena. She is also interested in and creates paintings as a means of understanding.</p>
      <p>More about the artist at:</p>
      <p><a href="https://shiorihigashiyama.com/paintings" target="_blank">https://shiorihigashiyama.com/paintings</a></p>
      `,
    },
  },
  {
    id: 18,
    projectName: "Vẽ trò chuyện trực tuyến / Digital Drawing Conversation",
    displayName: {
      vi: "Vẽ trò chuyện trực tuyến",
      en: "Digital Drawing Conversation",
    },
    artists: [
      {
        fullName: "Yujin Lee",
        country: "Korea",
      },
      {
        fullName: "Quỳnh Đông",
        country: "Vietnam",
      },
      {
        fullName: "Mai Huyền Chi",
        country: "Vietnam",
      },
    ],
    markerOffset: 15,
    multiCoordinates: [
      [130.766368, 43.764550],
      [104.885297, 7.868060]
    ],
    medias: [
      {
        url: "/images/digital_drawing/slide1.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide2.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide3.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide4.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide5.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide6.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide7.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide8.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide9.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide10.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide11.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide12.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide13.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide14.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide15.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide16.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide17.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide18.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide19.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide20.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide21.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide22.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide23.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide24.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide25.jpg",
        type: "image",
      },
      {
        url: "/images/digital_drawing/slide26.jpg",
        type: "image",
      },
      // {
      //   url: "https://vimeo.com/628183671",
      //   videoId: "628183671",
      //   type: "video",
      //   sourceType: "vimeo",
      // },
    ],
    displayDescription: {
      vi: `<p>Năm 2015, Yujin Lee giới thiệu thuật ngữ “Vẽ trò chuyện” qua một tựa để của một tác phẩm video đặt ra suy ngẫm về ý nghĩa của việc vẽ. Năm 2019, cô mở rộng ý tưởng trong triển lãm cá nhân của mình mình tại Bangkok, Thái Lan, nơi cô mời các nghệ sĩ người Thái ở địa phương sử dụng một kỹ thuật “vẽ tự động” để trình diễn một màn vẽ hợp hợp tác trực tiếp với cô trong một phòng trưng bày. Năm 2020, cô tiếp tục thử nghiệm thêm với khái niệm này bằng cách thêm vào những yếu tố của việc ‘kết bạn qua thư’ với khán giả tới xem triển lãm. Kể từ cuối năm 2020, Lee đã dấn thân vào công nghệ Thực tế Mở rộng (XR), tiếp tục “Vẽ trò chuyện” với các nghệ sĩ Hàn Quốc và nghệ si từ khắp nơi trên thế giới.</p>
      <p>Tháng 10/2021, Yujin Lee được mời thực hiện một sự kiện văn hóa công cộng tại Culturetank, Seoul (Hàn Quốc) với tên gọi “Time-Space Resonance”. Cô đưa ý tưởng “Digital Drawing Conversation” vào triển khai trong sự kiện 4 ngày này, và mong muốn được kết nối làm việc cùng với nghệ sĩ ở nhiều nơi trên thế giới. Cô được giới thiệu hợp tác với hai nghệ sĩ của MAP 2021 là nghệ sĩ thị giác Quỳnh Đông ở Zurich (Thụy Sĩ) và đạo diễn – nghệ sĩ thị giác Mai Huyền Chi tại Đà Nẵng (Việt Nam).</p>
      <p>Là một dự án bên lề của MAP 2021, ý tưởng Digital Drawing Conversation lại rất phù hợp với chủ đề “Khoảng cách TRẮNG”, khi mong muốn thiết lập những kênh làm việc-hợp tác từ xa mà dự án muốn hướng tới. Trên một nền tảng trực tuyến cho phép nhiều người tương tác cùng một lúc, Yujin Lee cùng với Quỳnh Đông và Mai Huyền Chi đã cùng nhau vẽ trong vòng 1 giờ đồng hồ, đồng thời vừa trò chuyện, chia sẻ về vai trò của phụ nữ trong công việc và cuộc sống, quan niệm và định kiến giới ở mỗi nơi họ sống, hay đời sống riêng tư, vừa thân mật vừa thầm kín. Bức vẽ trực tuyến đó được trưng bày ngay tại không gian, cùng với video ghi lại quá trình vừa vẽ vừa trò chuyện của 3 người.</p>
      <p>Một số ảnh chụp trong quá trình vẽ - trò chuyện được các nghệ sĩ chuyển in thành những chiếc áo phông trưng bày trong triển lãm này.</p>
      <p>Video vẽ trò chuyện trực tuyến xem tại:</p>
      <p><a href="https://vimeo.com/628183671" target="_blank">https://vimeo.com/628183671</a></p>
      <p>Thông tin đầy đủ về chương trình xem tại:</p>
      <p><a href="https://yujinleeart.myportfolio.com/drawing-conversations" target="_blank">https://yujinleeart.myportfolio.com/drawing-conversations</a></p>
      <p class="title-section">Tiểu Sử</p>
      <p>Yujin Lee là một nghệ sĩ thị giác, cô thử nghiệm với nghệ thuật tiến trình và nghệ thuật quan hệ qua tranh vẽ, video, trình diễn, các dự án đặc thù địa điểm, và sự hợp tác. Từ tác phẩm video năm 2013 mang tên 108 Lạy, khi Lee hợp tác với vũ công ba lê người Nhật, Emi Hariyama, ‘sự tương giao’ đã luôn là trọng tâm trong tác phẩm của Lee.</p>
      <p>Cùng với sự phát triển trong thực hành của cô, ‘sự tương giao’ này đã thành hình trong tác phẩm không chỉ như ‘người nghệ sĩ và đối tượng của cô’, mà còn là một thứ làm xáo trộn những ranh giới như vậy. Thêm vào đó, Lee thường tìm kiếm những loại ‘mối quan hệ’ mà không thể dễ dàng rũ bỏ. Trong những trường hợp đó, tác phẩm nghệ thuật được tạo ra không bao giờ có thể hoàn toàn được giải quyết, đặt thực hành của cô lên nền móng của truyền thống nghệ thuật tiến trình.</p>
      <p>Những gì còn lại cho người xem không phải là một đối tượng nghệ thuật có thể được tiêu thụ, mà là một trải nghiệm, kí ức và các ghi chép về nó, và có lẽ một sự vật (một thứ gì đó hữu hình) đã được định rằng sẽ bị chôn vùi ở chốn nào đó, hoàn toàn bị quên lãng cho đến khi...</p>
      <p>Vào đầu năm 2019, Lee chuyển từ New York đến đảo Jeju, mua lại một điền trang cũ bao gồm một nhà chính, nhà phụ, nông trại quýt, và một khu vườn. Cô đã cải tiến nơi đó thành một không gian sống/làm việc sáng tạo độc lập, và đang điều hành tại đó nơi lưu trú cho nghệ sĩ thử nghiệm và biệt lập. Gọi nó là Next Door to the Museum (Cạnh Bên Bảo Tàng), Lee hình dung nơi đó là một phòng thí nghiệm cho cá nhân và tập thể, một chốn mà những ranh giới của nghệ thuật và đời sống bị xáo trộn và che mờ. Cho tới nay, có tổng cộng 6 nghệ sĩ trong nước và quốc tế đã đi qua Next Door to the Museum Jeju.</p>
      <p>Quỳnh Đông sinh năm 1982 tại Hải Phòng. Cô theo học Trường Thiết kế ở Biel/Bienne để lấy bằng thiết kế đồ họa, tốt nghiệp Cử nhân Mỹ thuật tại Đại học Nghệ thuật Bern và nhận bằng Thạc sĩ ngành Mỹ thuật tại Đại học Nghệ thuật Zurich. Cô đã hoàn thành các chương trình lưu trú tại Sommerakademie im Zentrum Paul Klee ở Bern (SAK), International Studio & Curatorial Program (ISCP) tại New York, Rijksakademie van beeldende kunsten ở Amsterdam, MMCA Changdong điều hành bởi Bảo tàng Nghệ thuật Hiện đại và Đương đại Quốc gia Hàn Quốc tại Seoul, và Tháng Thực hành Nghệ thuật (MAP 2019) ở Heritage Space tại Hà Nội.</p>
      <p>Mai Huyền Chi (Chi Mai) là một cây bút kiêm nhà làm phim người Việt Nam.</p>
      <p>Tốt nghiệp chương trình Thạc sĩ Biên kịch tại Trường Điện ảnh London, cô từng đảm nhiệm vai trò biên kịch phim A Brixton Tale (Đề cử Phim truyện Hay nhất, Slamdance 2021), Chàng Vợ Của Em (Giải Cánh Diều Vàng cho Phim Điện ảnh Xuất sắc Nhất 2018), và Cô gái Đắk Lắk (2021). Tác phẩm đạo diễn đầu tay của cô, phim tài liệu ngắn "Thì Sông Cứ Chảy", lọt vào vòng chung cuộc giải Phim hay nhất năm 2015 của Vimeo. Tiếp nối bộ phim tài liệu này, Chi đang phát triển The River Knows Our Names, phim truyện đạo diễn đầu tay. Phim kể về cộng đồng vô quốc tịch trên sông Mê Kông gần biên giới Campuchia - Việt Nam và sẽ sớm tuyển người tham gia vào bộ phim. Dự án giành Giải thưởng Viễn Đông Udine tại Diễn đàn Tài trợ Điện ảnh của Hồng Kông và du ngoạn tới Thị trường Đồng Sản xuất Tiêu điểm Châu Á (Liên hoan phim Viễn Đông 2020), Locarno Open Doors, SEAPitch của Liên hoan phim Bangkok ASEAN, và Feature Lab của Liên hoan phim Quốc tế Singapore. Sản xuất dự tính sẽ tiến hành trong năm 2023.</p>
      <p>Ngoài phim ảnh, Chi còn hợp tác với các nghệ sĩ thuộc nhiều lĩnh vực khác nhau cùng sản xuất phim múa, sắp đặt video, và các tác phẩm trình diễn đa phương tiện.</p>
      `,
      en: `<p>In 2015, Yujin Lee introduced the term 'Drawing Conversation' through a title of a video work that contemplates the meaning of drawing. In 2019, she expanded the idea at her solo exhibition in Bangkok, Thailand, where she invited local Thai artists to use the technique of ‘automatic drawing’ to perform a live collaborative drawing with her in the gallery. In 2020, she experimented with the concept further by adding an element of ‘pen paling’ with the gallery visitors. Since the end of 2020, Lee has ventured into the Extended Reality (XR), continuing her ‘Drawing Conversation’ with Korean and international artists around the world.</p>
      <p>October 10/2021, Yujin Lee was invited to organize a cultural public event at Culturetank, Seoul (Korea) called “Time-Space Resonance”. She put the idea of ​​"Digital Drawing Conversation" into practice during this 4-day event, and looks forward to connecting and working with artists from different parts of the world. She was introduced to collaborate with two artists of MAP 2021, visual artist Quynh Dong in Zurich (Switzerland) and director - visual artist Mai Huyền Chi in Đà Nẵng (Vietnam).</p>
      <p>As a side project of MAP 2021, the idea of Digital Drawing Conversation is very resonant to the theme "WHITE distance", as the artist wants to establish the remote working-collaboration channels which happens to be the aims of this project. On an online platform that allows many people to interact at the same time, Yujin Lee, Quynh Dong and Mai Huyền Chi drew together for 1 hour, at the same time chatted and shared about the role of women in work and life, gender concepts and stereotypes in each place they live, or intimate and secret stories of their private lives. The online drawing is displayed in the exhibition space, along with a video recording the process of drawing and sharing by the three artists.</p>
      <p>Some screenshots taken during the drawing-talking process were transformed by the artists into T-shirts displayed in this exhibition.</p>
      <p>The video record of drawing conversation could be seen here:</p>
      <p><a href="https://vimeo.com/628183671" target="_blank">https://vimeo.com/628183671</a></p>
      <p>For full program information, please visit:</p>
      <p><a href="https://yujinleeart.myportfolio.com/drawing-conversations" target="_blank">https://yujinleeart.myportfolio.com/drawing-conversations</a></p>
      <p class="title-section">Biography</p>
      <p>Yujin Lee is a visual artist experimenting with process art and relational art through drawing, video, performance, site-specific projects, and collaborations. Since the 2013 video work, 108 Bows, where Lee collaborated with a Japanese ballerina, Emi Hariyama, ‘interrelationship’ has always been at the center of Lee’s work.</p>
      <p>As her practice evolved, this ‘interrelationship’ has manifested in her work not merely as ‘an artist and her subject matter,’ but one that muddles such boundaries. In addition, Lee tends to seek out the kind of ‘relationships’ that are not easily disposable. In such cases, the resulting artwork can never really fully be resolved, grounding her practice in the tradition of process art.</p>
      <p>What is left for the viewer is not a consumable art object, but rather an experience, its memory and documentations, and maybe an object (something that is tangible) that is destined to be kept but buried somewhere, totally forgotten until...</p>
      <p>In the beginning of 2019, Lee moved from New York to Jeju Island, acquiring an old farmhouse that includes a main house, sub house, tangerine barn, and a garden. She renovated the place into an independent creative live/work space, where she has been running an experimental and alternative artist residency. Calling it Next Door to the Museum, Lee envisions it to be a personal and collective laboratory where the boundaries of art and life is muddled and obscured. To this day, a total of 6 domestic and international artists have gone through Next Door to the Museum Jeju.</p>
      <p>Quynh Dong (b. 1982, Hai Phong, Vietnam) attended the Design School in Biel/Bienne for a degree in graphic design, graduated with a Bachelor of Fine Arts at the Bern University of Arts and earned her MA in Fine Arts at the Zurich University of the Arts. She completed her residency programs at The Sommerakademie im Zentrum Paul Klee in Bern (SAK), The International Studio & Curatorial Program (ISCP) in New York City, Rijksakademie van beeldende kunsten in Amsterdam, MMCA Changdong run by National Museum of Modern and Contemporary Art, Korea in Seoul and Month of Arts Practice (MAP) at Heritage Space in Hanoi. In 2016, she had her first solo exhibition Quynh by Night at Nha San Collective in Hanoi, Vietnam. Dong composes her works as paintings (conceptually). <a href="https://quynhdong.ch" target="_blank">https://quynhdong.ch</a></p>
      <p>Chi Mai (Mai Huyền Chi) is a Vietnamese writer-filmmaker.</p>
      <p>Graduating from the MA Screenwriting program at the London Film School, she has earned writing credits for A Brixton Tale (Nominee, Best Narrative Feature, Slamdance 2021), My Mr. Wife (Winner, Best Pictures, Golden Kite Film Festival, 2018), and The Girl from Daklak (2021). Her directorial debut was the short documentary Down The Stream which was a finalist for Vimeo's Best of the Year in 2015. Following this documentary, Chi is developing her feature-length directorial narrative debut, The River Knows Our Names. The film is about the stateless community on the Mekong River near the Cambodia-Vietnam border and will be casting its members. The project won Far East Udine Award at Hongkong’s Film Financing Forum, traveled to Focus Asia Co-production Market (2020 Far East Film Festival), Locarno Open Doors, Bangkok ASEAN Film Festival's SEAPitch, and Singapore International Film Festival's Feature Lab. The production is set for 2023.</p>
      <p>Besides films, Chi collaborates with artists of different disciplines to produce dance films, video installations, and performative multi-media works. <a href="https://www.chimaian.com" target="_blank">https://www.chimaian.com</a></p>
      `,
    },
  },
]

let artworksMap = []

forEach(ARTWORKS, item => {
  if (item.multiCoordinates) {
    item.multiCoordinates.map(geoItem =>
      artworksMap.push({ ...item, coordinates: geoItem })
    )
  } else if (item.coordinates) {
    artworksMap.push(item)
  }
})

export const ARTWORKS_MAP = artworksMap
